
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.7.1
 * Query Engine version: 0ca5ccbcfa6bdc81c003cf549abe4269f59c41e5
 */
Prisma.prismaVersion = {
  client: "5.7.1",
  engine: "0ca5ccbcfa6bdc81c003cf549abe4269f59c41e5"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.SpaceScalarFieldEnum = {
  id: 'id',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  name: 'name',
  domain: 'domain',
  customDomain: 'customDomain',
  isCustomDomainVerified: 'isCustomDomainVerified',
  paidTier: 'paidTier',
  discordServerId: 'discordServerId',
  defaultVotingDuration: 'defaultVotingDuration',
  enableTestnets: 'enableTestnets',
  snapshotDomain: 'snapshotDomain',
  spaceImage: 'spaceImage',
  spaceArtwork: 'spaceArtwork',
  emailBrandColor: 'emailBrandColor',
  emailBrandArtwork: 'emailBrandArtwork',
  credentialLogo: 'credentialLogo',
  defaultPostCategoryId: 'defaultPostCategoryId',
  defaultPagePermissionGroup: 'defaultPagePermissionGroup',
  defaultPublicPages: 'defaultPublicPages',
  homePageId: 'homePageId',
  notificationToggles: 'notificationToggles',
  requireProposalTemplate: 'requireProposalTemplate',
  publicProposalTemplates: 'publicProposalTemplates',
  permissionConfigurationMode: 'permissionConfigurationMode',
  publicBountyBoard: 'publicBountyBoard',
  publicProposals: 'publicProposals',
  xpsEngineId: 'xpsEngineId',
  useOnchainCredentials: 'useOnchainCredentials',
  credentialsChainId: 'credentialsChainId',
  credentialsWallet: 'credentialsWallet',
  kycOption: 'kycOption',
  primaryMemberIdentity: 'primaryMemberIdentity',
  superApiTokenId: 'superApiTokenId',
  webhookSubscriptionUrl: 'webhookSubscriptionUrl',
  webhookSigningSecret: 'webhookSigningSecret',
  origin: 'origin',
  hiddenFeatures: 'hiddenFeatures',
  features: 'features',
  memberProfiles: 'memberProfiles',
  blockQuota: 'blockQuota',
  requireMembersTwoFactorAuth: 'requireMembersTwoFactorAuth',
  tokenGateMessage: 'tokenGateMessage'
};

exports.Prisma.StripeSubscriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  spaceId: 'spaceId',
  customerId: 'customerId',
  subscriptionId: 'subscriptionId',
  deletedAt: 'deletedAt'
};

exports.Prisma.SpaceApiTokenScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  spaceId: 'spaceId',
  token: 'token'
};

exports.Prisma.SuperApiTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  name: 'name'
};

exports.Prisma.PageScalarFieldEnum = {
  id: 'id',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  deletedBy: 'deletedBy',
  title: 'title',
  content: 'content',
  contentText: 'contentText',
  galleryImage: 'galleryImage',
  hasContent: 'hasContent',
  headerImage: 'headerImage',
  icon: 'icon',
  path: 'path',
  isTemplate: 'isTemplate',
  parentId: 'parentId',
  spaceId: 'spaceId',
  additionalPaths: 'additionalPaths',
  type: 'type',
  boardId: 'boardId',
  autoGenerated: 'autoGenerated',
  index: 'index',
  cardId: 'cardId',
  proposalId: 'proposalId',
  fullWidth: 'fullWidth',
  fontFamily: 'fontFamily',
  fontSizeSmall: 'fontSizeSmall',
  version: 'version',
  bountyId: 'bountyId',
  syncWithPageId: 'syncWithPageId',
  convertedProposalId: 'convertedProposalId',
  sourceTemplateId: 'sourceTemplateId',
  isLocked: 'isLocked',
  lockedBy: 'lockedBy',
  lensPostLink: 'lensPostLink'
};

exports.Prisma.UserSpaceActionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  distinctUserId: 'distinctUserId',
  pageId: 'pageId',
  postId: 'postId',
  action: 'action',
  meta: 'meta',
  pageType: 'pageType',
  spaceId: 'spaceId'
};

exports.Prisma.PageCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  content: 'content',
  contentText: 'contentText',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deletedBy: 'deletedBy',
  parentId: 'parentId',
  pageId: 'pageId',
  lensCommentLink: 'lensCommentLink'
};

exports.Prisma.PageCommentVoteScalarFieldEnum = {
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  upvoted: 'upvoted',
  commentId: 'commentId'
};

exports.Prisma.PageDiffScalarFieldEnum = {
  data: 'data',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  pageId: 'pageId',
  version: 'version'
};

exports.Prisma.BlockScalarFieldEnum = {
  id: 'id',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  spaceId: 'spaceId',
  parentId: 'parentId',
  rootId: 'rootId',
  schema: 'schema',
  type: 'type',
  title: 'title',
  fields: 'fields'
};

exports.Prisma.UserVoteScalarFieldEnum = {
  voteId: 'voteId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  choices: 'choices',
  tokenAmount: 'tokenAmount'
};

exports.Prisma.VoteOptionsScalarFieldEnum = {
  name: 'name',
  voteId: 'voteId'
};

exports.Prisma.VoteScalarFieldEnum = {
  id: 'id',
  pageId: 'pageId',
  postId: 'postId',
  title: 'title',
  description: 'description',
  content: 'content',
  contentText: 'contentText',
  deadline: 'deadline',
  status: 'status',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  threshold: 'threshold',
  maxChoices: 'maxChoices',
  type: 'type',
  strategy: 'strategy',
  context: 'context',
  chainId: 'chainId',
  tokenAddress: 'tokenAddress',
  blockNumber: 'blockNumber'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  avatar: 'avatar',
  avatarContract: 'avatarContract',
  avatarTokenId: 'avatarTokenId',
  avatarChain: 'avatarChain',
  username: 'username',
  isBot: 'isBot',
  path: 'path',
  identityType: 'identityType',
  email: 'email',
  emailNotifications: 'emailNotifications',
  emailNewsletter: 'emailNewsletter',
  xpsEngineId: 'xpsEngineId',
  publishToLensDefault: 'publishToLensDefault',
  connectOnboarded: 'connectOnboarded',
  primaryWalletId: 'primaryWalletId',
  spacesOrder: 'spacesOrder',
  claimed: 'claimed'
};

exports.Prisma.FarcasterUserScalarFieldEnum = {
  fid: 'fid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  account: 'account',
  userId: 'userId'
};

exports.Prisma.VerifiedEmailScalarFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  avatarUrl: 'avatarUrl',
  userId: 'userId'
};

exports.Prisma.UserWalletScalarFieldEnum = {
  id: 'id',
  address: 'address',
  userId: 'userId',
  ensname: 'ensname'
};

exports.Prisma.UserSpaceNotificationSettingsScalarFieldEnum = {
  userId: 'userId',
  spaceId: 'spaceId',
  forumCategories: 'forumCategories',
  forumCategoriesMode: 'forumCategoriesMode'
};

exports.Prisma.UserNotificationStateScalarFieldEnum = {
  snoozedUntil: 'snoozedUntil',
  snoozeMessage: 'snoozeMessage',
  userId: 'userId'
};

exports.Prisma.UserNotificationScalarFieldEnum = {
  taskId: 'taskId',
  createdAt: 'createdAt',
  userId: 'userId',
  type: 'type',
  channel: 'channel'
};

exports.Prisma.UserDetailsScalarFieldEnum = {
  id: 'id',
  description: 'description',
  social: 'social',
  timezone: 'timezone',
  locale: 'locale'
};

exports.Prisma.TelegramUserScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  telegramId: 'telegramId',
  account: 'account'
};

exports.Prisma.DiscordUserScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  discordId: 'discordId',
  account: 'account'
};

exports.Prisma.PoapScalarFieldEnum = {
  id: 'id',
  tokenId: 'tokenId',
  userId: 'userId',
  walletAddress: 'walletAddress',
  isHidden: 'isHidden'
};

exports.Prisma.FavoritePageScalarFieldEnum = {
  pageId: 'pageId',
  userId: 'userId',
  index: 'index'
};

exports.Prisma.UserTokenGateScalarFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  userId: 'userId',
  tokenGateConnectedDate: 'tokenGateConnectedDate',
  jwt: 'jwt',
  tokenGateId: 'tokenGateId',
  grantedRoles: 'grantedRoles'
};

exports.Prisma.SpaceRoleScalarFieldEnum = {
  spaceId: 'spaceId',
  userId: 'userId',
  id: 'id',
  isAdmin: 'isAdmin',
  isGuest: 'isGuest',
  createdAt: 'createdAt',
  xpsUserId: 'xpsUserId',
  tokenGateId: 'tokenGateId',
  joinedViaLink: 'joinedViaLink',
  onboarded: 'onboarded'
};

exports.Prisma.InviteLinkScalarFieldEnum = {
  id: 'id',
  code: 'code',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  maxAgeMinutes: 'maxAgeMinutes',
  maxUses: 'maxUses',
  useCount: 'useCount',
  visibleOn: 'visibleOn'
};

exports.Prisma.BountyScalarFieldEnum = {
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dueDate: 'dueDate',
  rewardAmount: 'rewardAmount',
  rewardToken: 'rewardToken',
  rewardType: 'rewardType',
  status: 'status',
  id: 'id',
  chainId: 'chainId',
  suggestedBy: 'suggestedBy',
  allowMultipleApplications: 'allowMultipleApplications',
  approveSubmitters: 'approveSubmitters',
  submissionsLocked: 'submissionsLocked',
  maxSubmissions: 'maxSubmissions',
  customReward: 'customReward',
  selectedCredentialTemplates: 'selectedCredentialTemplates',
  fields: 'fields',
  githubIssueUrl: 'githubIssueUrl',
  proposalId: 'proposalId'
};

exports.Prisma.BountyPermissionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  spaceId: 'spaceId',
  roleId: 'roleId',
  public: 'public',
  bountyId: 'bountyId',
  permissionLevel: 'permissionLevel',
  operations: 'operations'
};

exports.Prisma.ApplicationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  bountyId: 'bountyId',
  createdBy: 'createdBy',
  walletAddress: 'walletAddress',
  rewardInfo: 'rewardInfo',
  message: 'message',
  messageNodes: 'messageNodes',
  spaceId: 'spaceId',
  status: 'status',
  submission: 'submission',
  submissionNodes: 'submissionNodes',
  acceptedBy: 'acceptedBy',
  reviewedBy: 'reviewedBy'
};

exports.Prisma.TransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  transactionId: 'transactionId',
  safeTxHash: 'safeTxHash',
  chainId: 'chainId',
  applicationId: 'applicationId'
};

exports.Prisma.TokenGateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  conditions: 'conditions',
  resourceId: 'resourceId',
  userRole: 'userRole',
  accessTypes: 'accessTypes',
  type: 'type'
};

exports.Prisma.PaymentMethodScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  chainId: 'chainId',
  contractAddress: 'contractAddress',
  tokenName: 'tokenName',
  tokenSymbol: 'tokenSymbol',
  tokenDecimals: 'tokenDecimals',
  tokenLogo: 'tokenLogo',
  gnosisSafeAddress: 'gnosisSafeAddress',
  walletType: 'walletType'
};

exports.Prisma.UserGnosisSafeScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  chainId: 'chainId',
  address: 'address',
  name: 'name',
  isHidden: 'isHidden',
  threshold: 'threshold',
  owners: 'owners'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  externalId: 'externalId',
  name: 'name',
  spaceId: 'spaceId',
  source: 'source',
  sourceId: 'sourceId'
};

exports.Prisma.TokenGateToRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  tokenGateId: 'tokenGateId',
  roleId: 'roleId'
};

exports.Prisma.InviteLinkToRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  inviteLinkId: 'inviteLinkId',
  roleId: 'roleId'
};

exports.Prisma.SpaceRoleToRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  spaceRoleId: 'spaceRoleId',
  roleId: 'roleId'
};

exports.Prisma.PagePermissionScalarFieldEnum = {
  pageId: 'pageId',
  userId: 'userId',
  id: 'id',
  permissionLevel: 'permissionLevel',
  permissions: 'permissions',
  roleId: 'roleId',
  spaceId: 'spaceId',
  inheritedFromPermission: 'inheritedFromPermission',
  public: 'public',
  allowDiscovery: 'allowDiscovery'
};

exports.Prisma.SpacePermissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  operations: 'operations',
  forSpaceId: 'forSpaceId',
  roleId: 'roleId',
  spaceId: 'spaceId',
  userId: 'userId'
};

exports.Prisma.ThreadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  pageId: 'pageId',
  context: 'context',
  userId: 'userId',
  resolved: 'resolved',
  spaceId: 'spaceId',
  updatedAt: 'updatedAt',
  accessGroups: 'accessGroups',
  fieldAnswerId: 'fieldAnswerId'
};

exports.Prisma.CommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  threadId: 'threadId',
  content: 'content',
  userId: 'userId',
  pageId: 'pageId',
  spaceId: 'spaceId',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProposalScalarFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  status: 'status',
  archived: 'archived',
  archivedByAdmin: 'archivedByAdmin',
  reviewedBy: 'reviewedBy',
  reviewedAt: 'reviewedAt',
  publishedAt: 'publishedAt',
  publishToLens: 'publishToLens',
  fields: 'fields',
  selectedCredentialTemplates: 'selectedCredentialTemplates',
  workflowId: 'workflowId',
  formId: 'formId',
  projectId: 'projectId'
};

exports.Prisma.ProposalWorkflowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  spaceId: 'spaceId',
  index: 'index',
  title: 'title',
  draftReminder: 'draftReminder',
  privateEvaluations: 'privateEvaluations',
  evaluations: 'evaluations'
};

exports.Prisma.ProposalEvaluationPermissionScalarFieldEnum = {
  id: 'id',
  operation: 'operation',
  evaluationId: 'evaluationId',
  roleId: 'roleId',
  userId: 'userId',
  systemRole: 'systemRole'
};

exports.Prisma.ProposalEvaluationScalarFieldEnum = {
  id: 'id',
  index: 'index',
  title: 'title',
  type: 'type',
  completedAt: 'completedAt',
  declinedAt: 'declinedAt',
  snapshotId: 'snapshotId',
  snapshotExpiry: 'snapshotExpiry',
  decidedBy: 'decidedBy',
  proposalId: 'proposalId',
  voteSettings: 'voteSettings',
  voteId: 'voteId',
  actionLabels: 'actionLabels',
  notificationLabels: 'notificationLabels',
  requiredReviews: 'requiredReviews',
  finalStep: 'finalStep',
  appealRequiredReviews: 'appealRequiredReviews',
  appealable: 'appealable',
  appealedAt: 'appealedAt',
  appealedBy: 'appealedBy',
  appealReason: 'appealReason',
  shareReviews: 'shareReviews',
  dueDate: 'dueDate',
  showAuthorResultsOnRubricFail: 'showAuthorResultsOnRubricFail',
  result: 'result'
};

exports.Prisma.ProposalBlockScalarFieldEnum = {
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  spaceId: 'spaceId',
  rootId: 'rootId',
  id: 'id',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  parentId: 'parentId',
  schema: 'schema',
  type: 'type',
  title: 'title',
  fields: 'fields'
};

exports.Prisma.RewardBlockScalarFieldEnum = {
  id: 'id',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  spaceId: 'spaceId',
  parentId: 'parentId',
  rootId: 'rootId',
  schema: 'schema',
  type: 'type',
  title: 'title',
  fields: 'fields'
};

exports.Prisma.ProposalAuthorScalarFieldEnum = {
  proposalId: 'proposalId',
  userId: 'userId'
};

exports.Prisma.ProposalReviewerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  proposalId: 'proposalId',
  roleId: 'roleId',
  userId: 'userId',
  systemRole: 'systemRole',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProposalEvaluationApproverScalarFieldEnum = {
  id: 'id',
  proposalId: 'proposalId',
  roleId: 'roleId',
  userId: 'userId',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProposalAppealReviewerScalarFieldEnum = {
  id: 'id',
  proposalId: 'proposalId',
  roleId: 'roleId',
  userId: 'userId',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProposalRubricCriteriaScalarFieldEnum = {
  id: 'id',
  index: 'index',
  title: 'title',
  description: 'description',
  proposalId: 'proposalId',
  type: 'type',
  parameters: 'parameters',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProposalRubricCriteriaAnswerScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rubricCriteriaId: 'rubricCriteriaId',
  proposalId: 'proposalId',
  userId: 'userId',
  response: 'response',
  comment: 'comment',
  evaluationId: 'evaluationId'
};

exports.Prisma.DraftProposalRubricCriteriaAnswerScalarFieldEnum = {
  rubricCriteriaId: 'rubricCriteriaId',
  proposalId: 'proposalId',
  userId: 'userId',
  response: 'response',
  comment: 'comment',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProfileItemScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  isHidden: 'isHidden',
  metadata: 'metadata',
  type: 'type',
  isPinned: 'isPinned',
  walletId: 'walletId'
};

exports.Prisma.WorkspaceEventScalarFieldEnum = {
  id: 'id',
  actorId: 'actorId',
  type: 'type',
  meta: 'meta',
  spaceId: 'spaceId',
  pageId: 'pageId',
  createdAt: 'createdAt'
};

exports.Prisma.MemberPropertyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  spaceId: 'spaceId',
  name: 'name',
  type: 'type',
  options: 'options',
  index: 'index',
  enabledViews: 'enabledViews',
  required: 'required'
};

exports.Prisma.MemberPropertyValueScalarFieldEnum = {
  id: 'id',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  memberPropertyId: 'memberPropertyId',
  spaceId: 'spaceId',
  userId: 'userId',
  value: 'value'
};

exports.Prisma.MemberPropertyPermissionScalarFieldEnum = {
  id: 'id',
  roleId: 'roleId',
  memberPropertyPermissionLevel: 'memberPropertyPermissionLevel',
  memberPropertyId: 'memberPropertyId'
};

exports.Prisma.PostCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  path: 'path',
  spaceId: 'spaceId'
};

exports.Prisma.PostScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  id: 'id',
  title: 'title',
  content: 'content',
  contentText: 'contentText',
  path: 'path',
  categoryId: 'categoryId',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  pinned: 'pinned',
  locked: 'locked',
  proposalId: 'proposalId',
  isDraft: 'isDraft'
};

exports.Prisma.PostToPostTagScalarFieldEnum = {
  postId: 'postId',
  postTagId: 'postTagId'
};

exports.Prisma.PostUpDownVoteScalarFieldEnum = {
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  upvoted: 'upvoted',
  postId: 'postId'
};

exports.Prisma.PostCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  content: 'content',
  contentText: 'contentText',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deletedBy: 'deletedBy',
  parentId: 'parentId',
  postId: 'postId'
};

exports.Prisma.ApplicationCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  content: 'content',
  contentText: 'contentText',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deletedBy: 'deletedBy',
  parentId: 'parentId',
  applicationId: 'applicationId'
};

exports.Prisma.PostCommentUpDownVoteScalarFieldEnum = {
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  upvoted: 'upvoted',
  commentId: 'commentId',
  postId: 'postId'
};

exports.Prisma.PostTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  spaceId: 'spaceId'
};

exports.Prisma.UnstoppableDomainScalarFieldEnum = {
  id: 'id',
  domain: 'domain',
  userId: 'userId'
};

exports.Prisma.WebhookSubscriptionScalarFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  scope: 'scope',
  spaceId: 'spaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.GoogleAccountScalarFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  avatarUrl: 'avatarUrl',
  userId: 'userId'
};

exports.Prisma.GoogleCredentialScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  expiredAt: 'expiredAt',
  error: 'error',
  name: 'name',
  refreshToken: 'refreshToken',
  scope: 'scope',
  userId: 'userId'
};

exports.Prisma.PostCategoryPermissionScalarFieldEnum = {
  id: 'id',
  permissionLevel: 'permissionLevel',
  postCategoryId: 'postCategoryId',
  categoryOperations: 'categoryOperations',
  postOperations: 'postOperations',
  roleId: 'roleId',
  spaceId: 'spaceId',
  public: 'public'
};

exports.Prisma.ApiPageKeyScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  pageId: 'pageId',
  apiKey: 'apiKey',
  type: 'type'
};

exports.Prisma.BlockCountScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  count: 'count',
  spaceId: 'spaceId',
  details: 'details'
};

exports.Prisma.UserNotificationMetadataScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  deletedAt: 'deletedAt',
  seenAt: 'seenAt',
  archivedAt: 'archivedAt',
  channel: 'channel',
  spaceId: 'spaceId',
  userId: 'userId',
  messageId: 'messageId'
};

exports.Prisma.BountyNotificationScalarFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  bountyId: 'bountyId',
  applicationId: 'applicationId',
  type: 'type'
};

exports.Prisma.DocumentNotificationScalarFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  pageId: 'pageId',
  mentionId: 'mentionId',
  inlineCommentId: 'inlineCommentId',
  type: 'type',
  postCommentId: 'postCommentId',
  pageCommentId: 'pageCommentId',
  postId: 'postId',
  content: 'content',
  applicationCommentId: 'applicationCommentId'
};

exports.Prisma.CardNotificationScalarFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  cardId: 'cardId',
  personPropertyId: 'personPropertyId',
  type: 'type'
};

exports.Prisma.PostNotificationScalarFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  postId: 'postId',
  type: 'type'
};

exports.Prisma.ProposalNotificationScalarFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  proposalId: 'proposalId',
  type: 'type',
  evaluationId: 'evaluationId'
};

exports.Prisma.VoteNotificationScalarFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  voteId: 'voteId',
  type: 'type'
};

exports.Prisma.CustomNotificationScalarFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  type: 'type',
  content: 'content'
};

exports.Prisma.SQSMessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  payload: 'payload'
};

exports.Prisma.BlacklistedSpaceUserScalarFieldEnum = {
  userId: 'userId',
  spaceId: 'spaceId',
  discordId: 'discordId',
  walletAddresses: 'walletAddresses',
  emails: 'emails',
  createdAt: 'createdAt'
};

exports.Prisma.BlacklistedUserScalarFieldEnum = {
  userId: 'userId',
  discordId: 'discordId',
  walletAddresses: 'walletAddresses',
  emails: 'emails',
  createdAt: 'createdAt'
};

exports.Prisma.AdditionalBlockQuotaScalarFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  expiresAt: 'expiresAt',
  blockCount: 'blockCount',
  createdAt: 'createdAt'
};

exports.Prisma.FormScalarFieldEnum = {
  id: 'id',
  spaceId: 'spaceId'
};

exports.Prisma.FormFieldScalarFieldEnum = {
  id: 'id',
  type: 'type',
  index: 'index',
  name: 'name',
  description: 'description',
  required: 'required',
  private: 'private',
  options: 'options',
  formId: 'formId',
  fieldConfig: 'fieldConfig',
  dependsOnStepIndex: 'dependsOnStepIndex'
};

exports.Prisma.FormFieldAnswerScalarFieldEnum = {
  id: 'id',
  fieldId: 'fieldId',
  type: 'type',
  value: 'value',
  proposalId: 'proposalId',
  createdAt: 'createdAt'
};

exports.Prisma.CredentialTemplateScalarFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  name: 'name',
  organization: 'organization',
  description: 'description',
  schemaType: 'schemaType',
  schemaAddress: 'schemaAddress',
  createdAt: 'createdAt',
  credentialEvents: 'credentialEvents'
};

exports.Prisma.IssuedCredentialScalarFieldEnum = {
  id: 'id',
  credentialTemplateId: 'credentialTemplateId',
  proposalId: 'proposalId',
  rewardApplicationId: 'rewardApplicationId',
  schemaId: 'schemaId',
  ceramicId: 'ceramicId',
  ceramicRecord: 'ceramicRecord',
  onchainAttestationId: 'onchainAttestationId',
  onchainChainId: 'onchainChainId',
  hidden: 'hidden',
  userId: 'userId',
  credentialEvent: 'credentialEvent',
  createdAt: 'createdAt'
};

exports.Prisma.OtpScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  activatedAt: 'activatedAt',
  secret: 'secret',
  userId: 'userId',
  recoveryCodeId: 'recoveryCodeId'
};

exports.Prisma.RecoveryCodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  usedAt: 'usedAt',
  deletedAt: 'deletedAt',
  code: 'code'
};

exports.Prisma.CharmWalletScalarFieldEnum = {
  id: 'id',
  balance: 'balance',
  totalBalance: 'totalBalance',
  userId: 'userId',
  spaceId: 'spaceId'
};

exports.Prisma.CharmTransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  amount: 'amount',
  from: 'from',
  to: 'to',
  metadata: 'metadata'
};

exports.Prisma.FavoriteCredentialScalarFieldEnum = {
  id: 'id',
  index: 'index',
  chainId: 'chainId',
  userId: 'userId',
  attestationId: 'attestationId',
  issuedCredentialId: 'issuedCredentialId',
  gitcoinWalletAddress: 'gitcoinWalletAddress'
};

exports.Prisma.ReferralCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  createdAt: 'createdAt',
  userId: 'userId'
};

exports.Prisma.ReferralCodeUseEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  referrerId: 'referrerId',
  refereeId: 'refereeId'
};

exports.Prisma.PendingSafeTransactionScalarFieldEnum = {
  safeAddress: 'safeAddress',
  safeTxHash: 'safeTxHash',
  chainId: 'chainId',
  processed: 'processed',
  credentialType: 'credentialType',
  spaceId: 'spaceId',
  schemaId: 'schemaId',
  proposalIds: 'proposalIds',
  rewardIds: 'rewardIds',
  credentialContent: 'credentialContent'
};

exports.Prisma.ProjectMemberScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  teamLead: 'teamLead',
  name: 'name',
  walletAddress: 'walletAddress',
  email: 'email',
  farcasterId: 'farcasterId',
  socialUrls: 'socialUrls',
  userId: 'userId',
  projectId: 'projectId'
};

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  deletedAt: 'deletedAt',
  name: 'name',
  path: 'path',
  description: 'description',
  twitter: 'twitter',
  websites: 'websites',
  farcasterValues: 'farcasterValues',
  category: 'category',
  optimismCategory: 'optimismCategory',
  avatar: 'avatar',
  coverImage: 'coverImage',
  farcasterFrameImage: 'farcasterFrameImage',
  github: 'github',
  walletAddress: 'walletAddress',
  primaryContractAddress: 'primaryContractAddress',
  primaryContractDeployer: 'primaryContractDeployer',
  primaryContractDeployTxHash: 'primaryContractDeployTxHash',
  primaryContractChainId: 'primaryContractChainId',
  mintingWalletAddress: 'mintingWalletAddress',
  sunnyAwardsNumber: 'sunnyAwardsNumber',
  sunnyAwardsProjectType: 'sunnyAwardsProjectType',
  sunnyAwardsCategory: 'sunnyAwardsCategory',
  sunnyAwardsCategoryDetails: 'sunnyAwardsCategoryDetails',
  source: 'source'
};

exports.Prisma.ExternalProjectScalarFieldEnum = {
  id: 'id',
  metadata: 'metadata',
  recipient: 'recipient',
  source: 'source'
};

exports.Prisma.SpaceGithubConnectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  installationId: 'installationId',
  name: 'name',
  spaceId: 'spaceId'
};

exports.Prisma.RewardsGithubRepoScalarFieldEnum = {
  id: 'id',
  connectionId: 'connectionId',
  repositoryId: 'repositoryId',
  repositoryLabels: 'repositoryLabels',
  repositoryName: 'repositoryName',
  rewardAuthorId: 'rewardAuthorId',
  rewardTemplateId: 'rewardTemplateId'
};

exports.Prisma.SynapsCredentialScalarFieldEnum = {
  id: 'id',
  apiKey: 'apiKey',
  secret: 'secret',
  spaceId: 'spaceId'
};

exports.Prisma.SynapsUserKycScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  sessionId: 'sessionId',
  status: 'status',
  userId: 'userId',
  spaceId: 'spaceId'
};

exports.Prisma.PersonaCredentialScalarFieldEnum = {
  id: 'id',
  apiKey: 'apiKey',
  templateId: 'templateId',
  secret: 'secret',
  spaceId: 'spaceId'
};

exports.Prisma.PersonaUserKycScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  inquiryId: 'inquiryId',
  status: 'status',
  userId: 'userId',
  spaceId: 'spaceId'
};

exports.Prisma.ProposalEvaluationReviewScalarFieldEnum = {
  id: 'id',
  completedAt: 'completedAt',
  result: 'result',
  reviewerId: 'reviewerId',
  evaluationId: 'evaluationId',
  declineReasons: 'declineReasons',
  declineMessage: 'declineMessage'
};

exports.Prisma.DocusignCredentialScalarFieldEnum = {
  id: 'id',
  docusignAccountId: 'docusignAccountId',
  docusignAccountName: 'docusignAccountName',
  docusignApiBaseUrl: 'docusignApiBaseUrl',
  docusignWebhookId: 'docusignWebhookId',
  refreshToken: 'refreshToken',
  accessToken: 'accessToken',
  userId: 'userId',
  spaceId: 'spaceId',
  webhookApiKey: 'webhookApiKey'
};

exports.Prisma.DocumentToSignScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  completedAt: 'completedAt',
  docusignEnvelopeId: 'docusignEnvelopeId',
  status: 'status',
  title: 'title',
  evaluationId: 'evaluationId',
  proposalId: 'proposalId',
  spaceId: 'spaceId'
};

exports.Prisma.DocumentSignerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  documentToSignId: 'documentToSignId',
  completedAt: 'completedAt',
  completedBy: 'completedBy',
  email: 'email',
  name: 'name'
};

exports.Prisma.ProposalEvaluationAppealReviewScalarFieldEnum = {
  id: 'id',
  completedAt: 'completedAt',
  result: 'result',
  reviewerId: 'reviewerId',
  evaluationId: 'evaluationId',
  declineReasons: 'declineReasons',
  declineMessage: 'declineMessage'
};

exports.Prisma.PullRequestSummaryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  repoName: 'repoName',
  repoOwner: 'repoOwner',
  prTitle: 'prTitle',
  prNumber: 'prNumber',
  createdBy: 'createdBy',
  status: 'status',
  patches: 'patches',
  additions: 'additions',
  deletions: 'deletions',
  changedFiles: 'changedFiles',
  model: 'model',
  prompt: 'prompt',
  promptTokens: 'promptTokens',
  summary: 'summary',
  summaryTokens: 'summaryTokens'
};

exports.Prisma.DocusignAllowedRoleOrUserScalarFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  roleId: 'roleId',
  userId: 'userId'
};

exports.Prisma.OptimismProjectAttestationScalarFieldEnum = {
  projectRefUID: 'projectRefUID',
  farcasterIds: 'farcasterIds',
  chainId: 'chainId',
  name: 'name',
  metadataAttestationUID: 'metadataAttestationUID',
  metadataUrl: 'metadataUrl',
  metadata: 'metadata',
  timeCreated: 'timeCreated',
  projectId: 'projectId',
  projectAttestationRevoked: 'projectAttestationRevoked'
};

exports.Prisma.GitcoinProjectAttestationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  projectId: 'projectId',
  chainId: 'chainId',
  type: 'type',
  schemaId: 'schemaId',
  attestationUID: 'attestationUID',
  projectAttestationRevoked: 'projectAttestationRevoked'
};

exports.Prisma.CharmUserCredentialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  chainId: 'chainId',
  schemaId: 'schemaId',
  attestationUID: 'attestationUID',
  userId: 'userId'
};

exports.Prisma.CharmProjectCredentialScalarFieldEnum = {
  projectRefUID: 'projectRefUID',
  farcasterIds: 'farcasterIds',
  chainId: 'chainId',
  name: 'name',
  metadataAttestationUID: 'metadataAttestationUID',
  metadataUrl: 'metadataUrl',
  metadata: 'metadata',
  createdAt: 'createdAt',
  projectId: 'projectId',
  userId: 'userId',
  projectAttestationRevoked: 'projectAttestationRevoked'
};

exports.Prisma.CharmQualifyingEventCredentialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  qualifyingEventType: 'qualifyingEventType',
  chainId: 'chainId',
  schemaId: 'schemaId',
  attestationUID: 'attestationUID',
  userId: 'userId',
  resourceUrl: 'resourceUrl',
  proposalId: 'proposalId',
  projectId: 'projectId'
};

exports.Prisma.PushNotificationSubscriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  subscription: 'subscription',
  source: 'source',
  userId: 'userId'
};

exports.Prisma.ProductUpdatesFarcasterFrameScalarFieldEnum = {
  id: 'id',
  text: 'text',
  textContent: 'textContent',
  image: 'image',
  createdBy: 'createdBy',
  projectId: 'projectId',
  createdAt: 'createdAt',
  createdAtLocal: 'createdAtLocal'
};

exports.Prisma.ConnectWaitlistSlotScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  initialPosition: 'initialPosition',
  fid: 'fid',
  username: 'username',
  referredByFid: 'referredByFid',
  score: 'score',
  percentile: 'percentile',
  githubLogin: 'githubLogin',
  isPartnerAccount: 'isPartnerAccount'
};

exports.Prisma.CryptoEcosystemScalarFieldEnum = {
  subEcosystems: 'subEcosystems',
  title: 'title',
  repoUrls: 'repoUrls',
  organizations: 'organizations'
};

exports.Prisma.CryptoEcosystemChildScalarFieldEnum = {
  parentTitle: 'parentTitle',
  childTitle: 'childTitle'
};

exports.Prisma.CryptoEcosystemRepoScalarFieldEnum = {
  ecosystemTitle: 'ecosystemTitle',
  githubId: 'githubId',
  url: 'url',
  assignableUsers: 'assignableUsers',
  pullRequestAuthorsCount: 'pullRequestAuthorsCount',
  stargazerCount: 'stargazerCount',
  watcherCount: 'watcherCount',
  forkCount: 'forkCount',
  xtra: 'xtra'
};

exports.Prisma.CryptoEcosystemAuthorScalarFieldEnum = {
  login: 'login',
  name: 'name',
  email: 'email',
  twitter: 'twitter',
  xtra: 'xtra'
};

exports.Prisma.CryptoEcosystemPullRequestScalarFieldEnum = {
  date: 'date',
  githubId: 'githubId',
  repoGithubId: 'repoGithubId',
  title: 'title',
  userGithubLogin: 'userGithubLogin',
  xtra: 'xtra',
  ecosystemTitle: 'ecosystemTitle'
};

exports.Prisma.ScoutScalarFieldEnum = {
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  id: 'id',
  email: 'email',
  path: 'path',
  displayName: 'displayName',
  farcasterId: 'farcasterId',
  farcasterName: 'farcasterName',
  telegramId: 'telegramId',
  telegramName: 'telegramName',
  walletENS: 'walletENS',
  avatar: 'avatar',
  bio: 'bio',
  builderStatus: 'builderStatus',
  reappliedAt: 'reappliedAt',
  sendMarketing: 'sendMarketing',
  sendTransactionEmails: 'sendTransactionEmails',
  agreedToTermsAt: 'agreedToTermsAt',
  onboardedAt: 'onboardedAt',
  currentBalance: 'currentBalance',
  currentBalanceDevToken: 'currentBalanceDevToken',
  hasMoxieProfile: 'hasMoxieProfile',
  utmCampaign: 'utmCampaign',
  framesNotificationToken: 'framesNotificationToken',
  sendFarcasterNotification: 'sendFarcasterNotification',
  onchainProfileAttestationUid: 'onchainProfileAttestationUid',
  onchainProfileAttestationChainId: 'onchainProfileAttestationChainId',
  referralCode: 'referralCode'
};

exports.Prisma.ScoutEmailVerificationScalarFieldEnum = {
  code: 'code',
  sentAt: 'sentAt',
  completedAt: 'completedAt',
  email: 'email',
  scoutId: 'scoutId'
};

exports.Prisma.ScoutMergeEventScalarFieldEnum = {
  createdAt: 'createdAt',
  mergedFromId: 'mergedFromId',
  mergedToId: 'mergedToId',
  mergedRecords: 'mergedRecords'
};

exports.Prisma.BuilderStrikeScalarFieldEnum = {
  id: 'id',
  builderId: 'builderId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  githubEventId: 'githubEventId',
  onchainStrikeChainId: 'onchainStrikeChainId',
  onchainStrikeAttestationUid: 'onchainStrikeAttestationUid'
};

exports.Prisma.BuilderEventScalarFieldEnum = {
  id: 'id',
  builderId: 'builderId',
  type: 'type',
  week: 'week',
  season: 'season',
  createdAt: 'createdAt',
  description: 'description',
  bonusPartner: 'bonusPartner',
  githubEventId: 'githubEventId',
  gemsPayoutEventId: 'gemsPayoutEventId',
  nftPurchaseEventId: 'nftPurchaseEventId',
  weeklyClaimId: 'weeklyClaimId',
  scoutSocialQuestId: 'scoutSocialQuestId',
  dailyClaimEventId: 'dailyClaimEventId',
  dailyClaimStreakEventId: 'dailyClaimStreakEventId',
  onchainAchievementId: 'onchainAchievementId'
};

exports.Prisma.GithubUserScalarFieldEnum = {
  id: 'id',
  builderId: 'builderId',
  email: 'email',
  displayName: 'displayName',
  login: 'login',
  createdAt: 'createdAt'
};

exports.Prisma.GithubRepoScalarFieldEnum = {
  id: 'id',
  owner: 'owner',
  ownerType: 'ownerType',
  handPicked: 'handPicked',
  fork: 'fork',
  name: 'name',
  avatar: 'avatar',
  defaultBranch: 'defaultBranch',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  bonusPartner: 'bonusPartner'
};

exports.Prisma.GithubEventScalarFieldEnum = {
  id: 'id',
  repoId: 'repoId',
  pullRequestNumber: 'pullRequestNumber',
  commitHash: 'commitHash',
  type: 'type',
  isFirstPullRequest: 'isFirstPullRequest',
  title: 'title',
  url: 'url',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  completedAt: 'completedAt'
};

exports.Prisma.NFTPurchaseEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  paidInPoints: 'paidInPoints',
  tokensPurchased: 'tokensPurchased',
  pointsValue: 'pointsValue',
  builderNftId: 'builderNftId',
  txHash: 'txHash',
  txLogIndex: 'txLogIndex',
  walletAddress: 'walletAddress',
  senderWalletAddress: 'senderWalletAddress'
};

exports.Prisma.GemsPayoutEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  builderId: 'builderId',
  gems: 'gems',
  points: 'points',
  week: 'week',
  season: 'season'
};

exports.Prisma.PointsReceiptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  value: 'value',
  claimedAt: 'claimedAt',
  eventId: 'eventId',
  recipientId: 'recipientId',
  senderId: 'senderId',
  season: 'season'
};

exports.Prisma.GemsReceiptScalarFieldEnum = {
  id: 'id',
  eventId: 'eventId',
  createdAt: 'createdAt',
  value: 'value',
  type: 'type',
  onchainAttestationUid: 'onchainAttestationUid',
  onchainChainId: 'onchainChainId',
  onchainAttestationRevoked: 'onchainAttestationRevoked'
};

exports.Prisma.UserWeeklyStatsScalarFieldEnum = {
  id: 'id',
  lastUpdated: 'lastUpdated',
  userId: 'userId',
  gemsCollected: 'gemsCollected',
  week: 'week',
  season: 'season',
  rank: 'rank'
};

exports.Prisma.UserSeasonStatsScalarFieldEnum = {
  id: 'id',
  lastUpdated: 'lastUpdated',
  userId: 'userId',
  pointsEarnedAsBuilder: 'pointsEarnedAsBuilder',
  pointsEarnedAsScout: 'pointsEarnedAsScout',
  season: 'season',
  nftOwners: 'nftOwners',
  nftsSold: 'nftsSold',
  nftsPurchased: 'nftsPurchased',
  level: 'level'
};

exports.Prisma.UserAllTimeStatsScalarFieldEnum = {
  lastUpdated: 'lastUpdated',
  userId: 'userId',
  pointsEarnedAsBuilder: 'pointsEarnedAsBuilder',
  pointsEarnedAsScout: 'pointsEarnedAsScout'
};

exports.Prisma.BuilderNftScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  builderId: 'builderId',
  chainId: 'chainId',
  season: 'season',
  nftType: 'nftType',
  currentPrice: 'currentPrice',
  currentPriceDevToken: 'currentPriceDevToken',
  contractAddress: 'contractAddress',
  tokenId: 'tokenId',
  imageUrl: 'imageUrl',
  congratsImageUrl: 'congratsImageUrl',
  estimatedPayout: 'estimatedPayout',
  estimatedPayoutDevToken: 'estimatedPayoutDevToken'
};

exports.Prisma.ScoutGameActivityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  type: 'type',
  userId: 'userId',
  recipientType: 'recipientType',
  gemsReceiptId: 'gemsReceiptId',
  pointsReceiptId: 'pointsReceiptId',
  nftPurchaseEventId: 'nftPurchaseEventId',
  builderStrikeId: 'builderStrikeId',
  tokensReceiptId: 'tokensReceiptId'
};

exports.Prisma.PendingNftTransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  sourceChainTxHash: 'sourceChainTxHash',
  sourceChainId: 'sourceChainId',
  targetAmountReceived: 'targetAmountReceived',
  targetCurrencyContractAddress: 'targetCurrencyContractAddress',
  destinationChainId: 'destinationChainId',
  destinationChainTxHash: 'destinationChainTxHash',
  contractAddress: 'contractAddress',
  tokenId: 'tokenId',
  tokenAmount: 'tokenAmount',
  senderAddress: 'senderAddress',
  status: 'status'
};

exports.Prisma.ProposalMyWorkColumnScalarFieldEnum = {
  spaceId: 'spaceId',
  formFieldId: 'formFieldId'
};

exports.Prisma.BuilderCardActivityScalarFieldEnum = {
  builderId: 'builderId',
  last7Days: 'last7Days',
  last14Days: 'last14Days'
};

exports.Prisma.ScoutWalletScalarFieldEnum = {
  createdAt: 'createdAt',
  address: 'address',
  scoutId: 'scoutId',
  primary: 'primary',
  isSanctioned: 'isSanctioned',
  lastSanctionCheckedAt: 'lastSanctionCheckedAt'
};

exports.Prisma.WeeklyClaimsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  season: 'season',
  week: 'week',
  merkleTreeRoot: 'merkleTreeRoot',
  totalClaimable: 'totalClaimable',
  totalClaimableDevToken: 'totalClaimableDevToken',
  claims: 'claims',
  proofsMap: 'proofsMap'
};

exports.Prisma.TokensReceiptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  value: 'value',
  claimedAt: 'claimedAt',
  claimTxHash: 'claimTxHash',
  eventId: 'eventId',
  recipientWalletAddress: 'recipientWalletAddress',
  senderWalletAddress: 'senderWalletAddress'
};

exports.Prisma.ScoutNftScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  builderNftId: 'builderNftId',
  walletAddress: 'walletAddress',
  balance: 'balance'
};

exports.Prisma.ScoutSocialQuestScalarFieldEnum = {
  id: 'id',
  type: 'type',
  userId: 'userId',
  completedAt: 'completedAt',
  season: 'season'
};

exports.Prisma.ScoutDailyClaimEventScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  week: 'week',
  dayOfWeek: 'dayOfWeek'
};

exports.Prisma.ScoutDailyClaimStreakEventScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  week: 'week'
};

exports.Prisma.ReferralCodeEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  completedAt: 'completedAt',
  builderEventId: 'builderEventId',
  refereeId: 'refereeId',
  platform: 'platform',
  bonusBuilderEventId: 'bonusBuilderEventId'
};

exports.Prisma.TalentProfileScalarFieldEnum = {
  id: 'id',
  score: 'score',
  builderId: 'builderId',
  address: 'address',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartnerRewardEventScalarFieldEnum = {
  createdAt: 'createdAt',
  week: 'week',
  season: 'season',
  userId: 'userId',
  partner: 'partner',
  reward: 'reward'
};

exports.Prisma.AgentTelegramMessageScalarFieldEnum = {
  id: 'id',
  sentAt: 'sentAt',
  sender: 'sender',
  message: 'message',
  toolCalls: 'toolCalls',
  conversationTelegramId: 'conversationTelegramId',
  messageTelegramId: 'messageTelegramId'
};

exports.Prisma.ScoutProjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  avatar: 'avatar',
  path: 'path',
  description: 'description',
  website: 'website',
  github: 'github',
  deletedAt: 'deletedAt'
};

exports.Prisma.ScoutProjectMemberScalarFieldEnum = {
  projectId: 'projectId',
  userId: 'userId',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  deletedAt: 'deletedAt'
};

exports.Prisma.ScoutProjectContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  deployedAt: 'deployedAt',
  projectId: 'projectId',
  address: 'address',
  chainId: 'chainId',
  deployerId: 'deployerId',
  deployTxHash: 'deployTxHash',
  blockNumber: 'blockNumber',
  deletedAt: 'deletedAt'
};

exports.Prisma.ScoutProjectDeployerScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  address: 'address',
  createdAt: 'createdAt',
  verifiedAt: 'verifiedAt',
  verifiedBy: 'verifiedBy'
};

exports.Prisma.ScoutProjectWalletScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  projectId: 'projectId',
  address: 'address',
  chainId: 'chainId',
  chainType: 'chainType',
  deletedAt: 'deletedAt',
  verifiedAt: 'verifiedAt',
  verifiedBy: 'verifiedBy'
};

exports.Prisma.ScoutProjectContractDailyStatsScalarFieldEnum = {
  createdAt: 'createdAt',
  contractId: 'contractId',
  day: 'day',
  accounts: 'accounts',
  transactions: 'transactions',
  gasFees: 'gasFees',
  week: 'week'
};

exports.Prisma.ScoutProjectWalletDailyStatsScalarFieldEnum = {
  createdAt: 'createdAt',
  walletId: 'walletId',
  day: 'day',
  accounts: 'accounts',
  transactions: 'transactions',
  gasFees: 'gasFees',
  week: 'week'
};

exports.Prisma.ScoutProjectOnchainAchievementScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  createdAt: 'createdAt',
  tier: 'tier',
  week: 'week'
};

exports.Prisma.BuilderStatusEventScalarFieldEnum = {
  createdAt: 'createdAt',
  attestationUid: 'attestationUid',
  chainId: 'chainId',
  status: 'status',
  builderId: 'builderId'
};

exports.Prisma.PartnerRewardPayoutScalarFieldEnum = {
  id: 'id',
  walletAddress: 'walletAddress',
  amount: 'amount',
  claimedAt: 'claimedAt',
  txHash: 'txHash',
  payoutContractId: 'payoutContractId',
  meta: 'meta',
  deletedAt: 'deletedAt'
};

exports.Prisma.PartnerRewardPayoutContractScalarFieldEnum = {
  id: 'id',
  season: 'season',
  week: 'week',
  createdAt: 'createdAt',
  contractAddress: 'contractAddress',
  chainId: 'chainId',
  tokenAddress: 'tokenAddress',
  tokenDecimals: 'tokenDecimals',
  tokenSymbol: 'tokenSymbol',
  partner: 'partner',
  deployTxHash: 'deployTxHash',
  ipfsCid: 'ipfsCid',
  merkleTreeJson: 'merkleTreeJson',
  provider: 'provider',
  blockNumber: 'blockNumber'
};

exports.Prisma.ScoutProjectContractTransactionScalarFieldEnum = {
  contractId: 'contractId',
  createdAt: 'createdAt',
  from: 'from',
  to: 'to',
  status: 'status',
  txHash: 'txHash',
  txData: 'txData',
  blockNumber: 'blockNumber',
  gasUsed: 'gasUsed',
  gasPrice: 'gasPrice',
  gasCost: 'gasCost'
};

exports.Prisma.ScoutProjectWalletTransactionScalarFieldEnum = {
  walletId: 'walletId',
  chainId: 'chainId',
  createdAt: 'createdAt',
  from: 'from',
  to: 'to',
  status: 'status',
  txHash: 'txHash',
  txData: 'txData',
  blockNumber: 'blockNumber',
  gasUsed: 'gasUsed',
  gasPrice: 'gasPrice',
  gasCost: 'gasCost'
};

exports.Prisma.ScoutProjectContractPollEventScalarFieldEnum = {
  contractId: 'contractId',
  fromBlockNumber: 'fromBlockNumber',
  toBlockNumber: 'toBlockNumber',
  processedAt: 'processedAt',
  processTime: 'processTime'
};

exports.Prisma.ScoutProjectWalletPollEventScalarFieldEnum = {
  walletId: 'walletId',
  fromBlockNumber: 'fromBlockNumber',
  toBlockNumber: 'toBlockNumber',
  processedAt: 'processedAt',
  processTime: 'processTime'
};

exports.Prisma.ScoutFarcasterNotificationScalarFieldEnum = {
  id: 'id',
  fid: 'fid',
  userId: 'userId',
  notificationType: 'notificationType',
  templateVariables: 'templateVariables',
  createdAt: 'createdAt'
};

exports.Prisma.ScoutEmailNotificationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  templateVariables: 'templateVariables',
  userId: 'userId',
  notificationType: 'notificationType',
  createdAt: 'createdAt'
};

exports.Prisma.ScoutAppNotificationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  notificationType: 'notificationType',
  read: 'read',
  createdAt: 'createdAt',
  templateVariables: 'templateVariables'
};

exports.Prisma.ScoutMatchupScalarFieldEnum = {
  id: 'id',
  week: 'week',
  totalScore: 'totalScore',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  submittedAt: 'submittedAt',
  rank: 'rank',
  decentRegistrationTxId: 'decentRegistrationTxId',
  registrationTxId: 'registrationTxId'
};

exports.Prisma.BlockchainTransactionScalarFieldEnum = {
  id: 'id',
  hash: 'hash',
  chainId: 'chainId',
  status: 'status',
  error: 'error'
};

exports.Prisma.ScoutMatchupSelectionScalarFieldEnum = {
  id: 'id',
  matchupId: 'matchupId',
  developerNftId: 'developerNftId',
  gemsEarned: 'gemsEarned',
  creditsValue: 'creditsValue'
};

exports.Prisma.DeveloperNftListingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  builderNftId: 'builderNftId',
  sellerWallet: 'sellerWallet',
  buyerWallet: 'buyerWallet',
  price: 'price',
  priceDevToken: 'priceDevToken',
  amount: 'amount',
  signature: 'signature',
  hash: 'hash',
  completedAt: 'completedAt',
  order: 'order'
};

exports.Prisma.AirdropClaimScalarFieldEnum = {
  id: 'id',
  season: 'season',
  createdAt: 'createdAt',
  contractAddress: 'contractAddress',
  blockNumber: 'blockNumber',
  chainId: 'chainId',
  deployTxHash: 'deployTxHash',
  merkleTreeUrl: 'merkleTreeUrl'
};

exports.Prisma.AirdropClaimPayoutScalarFieldEnum = {
  id: 'id',
  airdropClaimId: 'airdropClaimId',
  claimAmount: 'claimAmount',
  donationAmount: 'donationAmount',
  claimTxHash: 'claimTxHash',
  donationTxHash: 'donationTxHash',
  walletAddress: 'walletAddress',
  claimedAt: 'claimedAt'
};

exports.Prisma.DraftSeasonOfferScalarFieldEnum = {
  id: 'id',
  season: 'season',
  value: 'value',
  developerId: 'developerId',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  makerWalletAddress: 'makerWalletAddress',
  status: 'status',
  decentError: 'decentError',
  decentTxHash: 'decentTxHash',
  sourceChainId: 'sourceChainId',
  txHash: 'txHash',
  chainId: 'chainId',
  completedAt: 'completedAt',
  decentPayload: 'decentPayload'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.SpaceOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  name: 'name',
  domain: 'domain',
  customDomain: 'customDomain',
  discordServerId: 'discordServerId',
  snapshotDomain: 'snapshotDomain',
  spaceImage: 'spaceImage',
  spaceArtwork: 'spaceArtwork',
  emailBrandColor: 'emailBrandColor',
  emailBrandArtwork: 'emailBrandArtwork',
  credentialLogo: 'credentialLogo',
  defaultPostCategoryId: 'defaultPostCategoryId',
  homePageId: 'homePageId',
  xpsEngineId: 'xpsEngineId',
  credentialsWallet: 'credentialsWallet',
  superApiTokenId: 'superApiTokenId',
  webhookSubscriptionUrl: 'webhookSubscriptionUrl',
  webhookSigningSecret: 'webhookSigningSecret',
  origin: 'origin'
};

exports.Prisma.StripeSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  customerId: 'customerId',
  subscriptionId: 'subscriptionId'
};

exports.Prisma.SpaceApiTokenOrderByRelevanceFieldEnum = {
  spaceId: 'spaceId',
  token: 'token'
};

exports.Prisma.SuperApiTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  token: 'token',
  name: 'name'
};

exports.Prisma.PageOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  deletedBy: 'deletedBy',
  title: 'title',
  contentText: 'contentText',
  galleryImage: 'galleryImage',
  headerImage: 'headerImage',
  icon: 'icon',
  path: 'path',
  parentId: 'parentId',
  spaceId: 'spaceId',
  additionalPaths: 'additionalPaths',
  boardId: 'boardId',
  cardId: 'cardId',
  proposalId: 'proposalId',
  bountyId: 'bountyId',
  syncWithPageId: 'syncWithPageId',
  convertedProposalId: 'convertedProposalId',
  sourceTemplateId: 'sourceTemplateId',
  lockedBy: 'lockedBy',
  lensPostLink: 'lensPostLink'
};

exports.Prisma.UserSpaceActionOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  distinctUserId: 'distinctUserId',
  pageId: 'pageId',
  postId: 'postId',
  pageType: 'pageType',
  spaceId: 'spaceId'
};

exports.Prisma.PageCommentOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  contentText: 'contentText',
  deletedBy: 'deletedBy',
  parentId: 'parentId',
  pageId: 'pageId',
  lensCommentLink: 'lensCommentLink'
};

exports.Prisma.PageCommentVoteOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  commentId: 'commentId'
};

exports.Prisma.PageDiffOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  pageId: 'pageId'
};

exports.Prisma.BlockOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  spaceId: 'spaceId',
  parentId: 'parentId',
  rootId: 'rootId',
  type: 'type',
  title: 'title'
};

exports.Prisma.UserVoteOrderByRelevanceFieldEnum = {
  voteId: 'voteId',
  userId: 'userId',
  choices: 'choices',
  tokenAmount: 'tokenAmount'
};

exports.Prisma.VoteOptionsOrderByRelevanceFieldEnum = {
  name: 'name',
  voteId: 'voteId'
};

exports.Prisma.VoteOrderByRelevanceFieldEnum = {
  id: 'id',
  pageId: 'pageId',
  postId: 'postId',
  title: 'title',
  description: 'description',
  contentText: 'contentText',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  tokenAddress: 'tokenAddress',
  blockNumber: 'blockNumber'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  avatar: 'avatar',
  avatarContract: 'avatarContract',
  avatarTokenId: 'avatarTokenId',
  username: 'username',
  path: 'path',
  email: 'email',
  xpsEngineId: 'xpsEngineId',
  primaryWalletId: 'primaryWalletId',
  spacesOrder: 'spacesOrder'
};

exports.Prisma.FarcasterUserOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.VerifiedEmailOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  avatarUrl: 'avatarUrl',
  userId: 'userId'
};

exports.Prisma.UserWalletOrderByRelevanceFieldEnum = {
  id: 'id',
  address: 'address',
  userId: 'userId',
  ensname: 'ensname'
};

exports.Prisma.UserSpaceNotificationSettingsOrderByRelevanceFieldEnum = {
  userId: 'userId',
  spaceId: 'spaceId',
  forumCategories: 'forumCategories'
};

exports.Prisma.UserNotificationStateOrderByRelevanceFieldEnum = {
  snoozeMessage: 'snoozeMessage',
  userId: 'userId'
};

exports.Prisma.UserNotificationOrderByRelevanceFieldEnum = {
  taskId: 'taskId',
  userId: 'userId'
};

exports.Prisma.UserDetailsOrderByRelevanceFieldEnum = {
  id: 'id',
  description: 'description',
  timezone: 'timezone',
  locale: 'locale'
};

exports.Prisma.TelegramUserOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.DiscordUserOrderByRelevanceFieldEnum = {
  userId: 'userId',
  discordId: 'discordId'
};

exports.Prisma.PoapOrderByRelevanceFieldEnum = {
  id: 'id',
  tokenId: 'tokenId',
  userId: 'userId',
  walletAddress: 'walletAddress'
};

exports.Prisma.FavoritePageOrderByRelevanceFieldEnum = {
  pageId: 'pageId',
  userId: 'userId'
};

exports.Prisma.UserTokenGateOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  userId: 'userId',
  jwt: 'jwt',
  tokenGateId: 'tokenGateId',
  grantedRoles: 'grantedRoles'
};

exports.Prisma.SpaceRoleOrderByRelevanceFieldEnum = {
  spaceId: 'spaceId',
  userId: 'userId',
  id: 'id',
  xpsUserId: 'xpsUserId',
  tokenGateId: 'tokenGateId'
};

exports.Prisma.InviteLinkOrderByRelevanceFieldEnum = {
  id: 'id',
  code: 'code',
  createdBy: 'createdBy',
  spaceId: 'spaceId'
};

exports.Prisma.BountyOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  rewardToken: 'rewardToken',
  id: 'id',
  suggestedBy: 'suggestedBy',
  customReward: 'customReward',
  selectedCredentialTemplates: 'selectedCredentialTemplates',
  githubIssueUrl: 'githubIssueUrl',
  proposalId: 'proposalId'
};

exports.Prisma.BountyPermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  spaceId: 'spaceId',
  roleId: 'roleId',
  bountyId: 'bountyId'
};

exports.Prisma.ApplicationOrderByRelevanceFieldEnum = {
  id: 'id',
  bountyId: 'bountyId',
  createdBy: 'createdBy',
  walletAddress: 'walletAddress',
  rewardInfo: 'rewardInfo',
  message: 'message',
  spaceId: 'spaceId',
  submission: 'submission',
  submissionNodes: 'submissionNodes',
  acceptedBy: 'acceptedBy',
  reviewedBy: 'reviewedBy'
};

exports.Prisma.TransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  safeTxHash: 'safeTxHash',
  chainId: 'chainId',
  applicationId: 'applicationId'
};

exports.Prisma.TokenGateOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  userRole: 'userRole',
  accessTypes: 'accessTypes'
};

exports.Prisma.PaymentMethodOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  contractAddress: 'contractAddress',
  tokenName: 'tokenName',
  tokenSymbol: 'tokenSymbol',
  tokenLogo: 'tokenLogo',
  gnosisSafeAddress: 'gnosisSafeAddress'
};

exports.Prisma.UserGnosisSafeOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  address: 'address',
  name: 'name',
  owners: 'owners'
};

exports.Prisma.RoleOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  externalId: 'externalId',
  name: 'name',
  spaceId: 'spaceId',
  sourceId: 'sourceId'
};

exports.Prisma.TokenGateToRoleOrderByRelevanceFieldEnum = {
  id: 'id',
  tokenGateId: 'tokenGateId',
  roleId: 'roleId'
};

exports.Prisma.InviteLinkToRoleOrderByRelevanceFieldEnum = {
  id: 'id',
  inviteLinkId: 'inviteLinkId',
  roleId: 'roleId'
};

exports.Prisma.SpaceRoleToRoleOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceRoleId: 'spaceRoleId',
  roleId: 'roleId'
};

exports.Prisma.PagePermissionOrderByRelevanceFieldEnum = {
  pageId: 'pageId',
  userId: 'userId',
  id: 'id',
  roleId: 'roleId',
  spaceId: 'spaceId',
  inheritedFromPermission: 'inheritedFromPermission'
};

exports.Prisma.SpacePermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  forSpaceId: 'forSpaceId',
  roleId: 'roleId',
  spaceId: 'spaceId',
  userId: 'userId'
};

exports.Prisma.ThreadOrderByRelevanceFieldEnum = {
  id: 'id',
  pageId: 'pageId',
  context: 'context',
  userId: 'userId',
  spaceId: 'spaceId',
  fieldAnswerId: 'fieldAnswerId'
};

exports.Prisma.CommentOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  userId: 'userId',
  pageId: 'pageId',
  spaceId: 'spaceId'
};

exports.Prisma.ProposalOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  reviewedBy: 'reviewedBy',
  selectedCredentialTemplates: 'selectedCredentialTemplates',
  workflowId: 'workflowId',
  formId: 'formId',
  projectId: 'projectId'
};

exports.Prisma.ProposalWorkflowOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  title: 'title'
};

exports.Prisma.ProposalEvaluationPermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  evaluationId: 'evaluationId',
  roleId: 'roleId',
  userId: 'userId'
};

exports.Prisma.ProposalEvaluationOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  snapshotId: 'snapshotId',
  decidedBy: 'decidedBy',
  proposalId: 'proposalId',
  voteId: 'voteId',
  appealedBy: 'appealedBy',
  appealReason: 'appealReason'
};

exports.Prisma.ProposalBlockOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  spaceId: 'spaceId',
  rootId: 'rootId',
  id: 'id',
  parentId: 'parentId',
  type: 'type',
  title: 'title'
};

exports.Prisma.RewardBlockOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  spaceId: 'spaceId',
  parentId: 'parentId',
  rootId: 'rootId',
  type: 'type',
  title: 'title'
};

exports.Prisma.ProposalAuthorOrderByRelevanceFieldEnum = {
  proposalId: 'proposalId',
  userId: 'userId'
};

exports.Prisma.ProposalReviewerOrderByRelevanceFieldEnum = {
  id: 'id',
  proposalId: 'proposalId',
  roleId: 'roleId',
  userId: 'userId',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProposalEvaluationApproverOrderByRelevanceFieldEnum = {
  id: 'id',
  proposalId: 'proposalId',
  roleId: 'roleId',
  userId: 'userId',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProposalAppealReviewerOrderByRelevanceFieldEnum = {
  id: 'id',
  proposalId: 'proposalId',
  roleId: 'roleId',
  userId: 'userId',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProposalRubricCriteriaOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  proposalId: 'proposalId',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProposalRubricCriteriaAnswerOrderByRelevanceFieldEnum = {
  rubricCriteriaId: 'rubricCriteriaId',
  proposalId: 'proposalId',
  userId: 'userId',
  comment: 'comment',
  evaluationId: 'evaluationId'
};

exports.Prisma.DraftProposalRubricCriteriaAnswerOrderByRelevanceFieldEnum = {
  rubricCriteriaId: 'rubricCriteriaId',
  proposalId: 'proposalId',
  userId: 'userId',
  comment: 'comment',
  evaluationId: 'evaluationId'
};

exports.Prisma.ProfileItemOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  walletId: 'walletId'
};

exports.Prisma.WorkspaceEventOrderByRelevanceFieldEnum = {
  id: 'id',
  actorId: 'actorId',
  spaceId: 'spaceId',
  pageId: 'pageId'
};

exports.Prisma.MemberPropertyOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  spaceId: 'spaceId',
  name: 'name'
};

exports.Prisma.MemberPropertyValueOrderByRelevanceFieldEnum = {
  id: 'id',
  updatedBy: 'updatedBy',
  memberPropertyId: 'memberPropertyId',
  spaceId: 'spaceId',
  userId: 'userId'
};

exports.Prisma.MemberPropertyPermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  roleId: 'roleId',
  memberPropertyId: 'memberPropertyId'
};

exports.Prisma.PostCategoryOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  path: 'path',
  spaceId: 'spaceId'
};

exports.Prisma.PostOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  contentText: 'contentText',
  path: 'path',
  categoryId: 'categoryId',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  proposalId: 'proposalId'
};

exports.Prisma.PostToPostTagOrderByRelevanceFieldEnum = {
  postId: 'postId',
  postTagId: 'postTagId'
};

exports.Prisma.PostUpDownVoteOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  postId: 'postId'
};

exports.Prisma.PostCommentOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  contentText: 'contentText',
  deletedBy: 'deletedBy',
  parentId: 'parentId',
  postId: 'postId'
};

exports.Prisma.ApplicationCommentOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  contentText: 'contentText',
  deletedBy: 'deletedBy',
  parentId: 'parentId',
  applicationId: 'applicationId'
};

exports.Prisma.PostCommentUpDownVoteOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  commentId: 'commentId',
  postId: 'postId'
};

exports.Prisma.PostTagOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  spaceId: 'spaceId'
};

exports.Prisma.UnstoppableDomainOrderByRelevanceFieldEnum = {
  id: 'id',
  domain: 'domain',
  userId: 'userId'
};

exports.Prisma.WebhookSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  scope: 'scope',
  spaceId: 'spaceId'
};

exports.Prisma.GoogleAccountOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  avatarUrl: 'avatarUrl',
  userId: 'userId'
};

exports.Prisma.GoogleCredentialOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  refreshToken: 'refreshToken',
  scope: 'scope',
  userId: 'userId'
};

exports.Prisma.PostCategoryPermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  postCategoryId: 'postCategoryId',
  roleId: 'roleId',
  spaceId: 'spaceId'
};

exports.Prisma.ApiPageKeyOrderByRelevanceFieldEnum = {
  createdBy: 'createdBy',
  pageId: 'pageId',
  apiKey: 'apiKey'
};

exports.Prisma.BlockCountOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceId: 'spaceId'
};

exports.Prisma.UserNotificationMetadataOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  spaceId: 'spaceId',
  userId: 'userId',
  messageId: 'messageId'
};

exports.Prisma.BountyNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  bountyId: 'bountyId',
  applicationId: 'applicationId',
  type: 'type'
};

exports.Prisma.DocumentNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  pageId: 'pageId',
  mentionId: 'mentionId',
  inlineCommentId: 'inlineCommentId',
  type: 'type',
  postCommentId: 'postCommentId',
  pageCommentId: 'pageCommentId',
  postId: 'postId',
  applicationCommentId: 'applicationCommentId'
};

exports.Prisma.CardNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  cardId: 'cardId',
  personPropertyId: 'personPropertyId',
  type: 'type'
};

exports.Prisma.PostNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  postId: 'postId',
  type: 'type'
};

exports.Prisma.ProposalNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  proposalId: 'proposalId',
  type: 'type',
  evaluationId: 'evaluationId'
};

exports.Prisma.VoteNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  voteId: 'voteId',
  type: 'type'
};

exports.Prisma.CustomNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  notificationMetadataId: 'notificationMetadataId',
  type: 'type'
};

exports.Prisma.SQSMessageOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.BlacklistedSpaceUserOrderByRelevanceFieldEnum = {
  userId: 'userId',
  spaceId: 'spaceId',
  discordId: 'discordId',
  walletAddresses: 'walletAddresses',
  emails: 'emails'
};

exports.Prisma.BlacklistedUserOrderByRelevanceFieldEnum = {
  userId: 'userId',
  discordId: 'discordId',
  walletAddresses: 'walletAddresses',
  emails: 'emails'
};

exports.Prisma.AdditionalBlockQuotaOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceId: 'spaceId'
};

exports.Prisma.FormOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceId: 'spaceId'
};

exports.Prisma.FormFieldOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  formId: 'formId'
};

exports.Prisma.FormFieldAnswerOrderByRelevanceFieldEnum = {
  id: 'id',
  fieldId: 'fieldId',
  proposalId: 'proposalId'
};

exports.Prisma.CredentialTemplateOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  name: 'name',
  organization: 'organization',
  description: 'description',
  schemaAddress: 'schemaAddress'
};

exports.Prisma.IssuedCredentialOrderByRelevanceFieldEnum = {
  id: 'id',
  credentialTemplateId: 'credentialTemplateId',
  proposalId: 'proposalId',
  rewardApplicationId: 'rewardApplicationId',
  schemaId: 'schemaId',
  ceramicId: 'ceramicId',
  onchainAttestationId: 'onchainAttestationId',
  userId: 'userId'
};

exports.Prisma.OtpOrderByRelevanceFieldEnum = {
  id: 'id',
  secret: 'secret',
  userId: 'userId',
  recoveryCodeId: 'recoveryCodeId'
};

exports.Prisma.RecoveryCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  code: 'code'
};

exports.Prisma.CharmWalletOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  spaceId: 'spaceId'
};

exports.Prisma.CharmTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  from: 'from',
  to: 'to'
};

exports.Prisma.FavoriteCredentialOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  attestationId: 'attestationId',
  issuedCredentialId: 'issuedCredentialId',
  gitcoinWalletAddress: 'gitcoinWalletAddress'
};

exports.Prisma.ReferralCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  code: 'code',
  userId: 'userId'
};

exports.Prisma.ReferralCodeUseEventOrderByRelevanceFieldEnum = {
  id: 'id',
  referrerId: 'referrerId',
  refereeId: 'refereeId'
};

exports.Prisma.PendingSafeTransactionOrderByRelevanceFieldEnum = {
  safeAddress: 'safeAddress',
  safeTxHash: 'safeTxHash',
  spaceId: 'spaceId',
  schemaId: 'schemaId',
  proposalIds: 'proposalIds',
  rewardIds: 'rewardIds'
};

exports.Prisma.ProjectMemberOrderByRelevanceFieldEnum = {
  id: 'id',
  updatedBy: 'updatedBy',
  name: 'name',
  walletAddress: 'walletAddress',
  email: 'email',
  socialUrls: 'socialUrls',
  userId: 'userId',
  projectId: 'projectId'
};

exports.Prisma.ProjectOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  name: 'name',
  path: 'path',
  description: 'description',
  twitter: 'twitter',
  websites: 'websites',
  farcasterValues: 'farcasterValues',
  category: 'category',
  optimismCategory: 'optimismCategory',
  avatar: 'avatar',
  coverImage: 'coverImage',
  farcasterFrameImage: 'farcasterFrameImage',
  github: 'github',
  walletAddress: 'walletAddress',
  primaryContractAddress: 'primaryContractAddress',
  primaryContractDeployer: 'primaryContractDeployer',
  primaryContractDeployTxHash: 'primaryContractDeployTxHash',
  mintingWalletAddress: 'mintingWalletAddress',
  sunnyAwardsCategory: 'sunnyAwardsCategory',
  sunnyAwardsCategoryDetails: 'sunnyAwardsCategoryDetails'
};

exports.Prisma.ExternalProjectOrderByRelevanceFieldEnum = {
  id: 'id',
  recipient: 'recipient'
};

exports.Prisma.SpaceGithubConnectionOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  installationId: 'installationId',
  name: 'name',
  spaceId: 'spaceId'
};

exports.Prisma.RewardsGithubRepoOrderByRelevanceFieldEnum = {
  id: 'id',
  connectionId: 'connectionId',
  repositoryId: 'repositoryId',
  repositoryLabels: 'repositoryLabels',
  repositoryName: 'repositoryName',
  rewardAuthorId: 'rewardAuthorId',
  rewardTemplateId: 'rewardTemplateId'
};

exports.Prisma.SynapsCredentialOrderByRelevanceFieldEnum = {
  id: 'id',
  apiKey: 'apiKey',
  secret: 'secret',
  spaceId: 'spaceId'
};

exports.Prisma.SynapsUserKycOrderByRelevanceFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  userId: 'userId',
  spaceId: 'spaceId'
};

exports.Prisma.PersonaCredentialOrderByRelevanceFieldEnum = {
  id: 'id',
  apiKey: 'apiKey',
  templateId: 'templateId',
  secret: 'secret',
  spaceId: 'spaceId'
};

exports.Prisma.PersonaUserKycOrderByRelevanceFieldEnum = {
  id: 'id',
  inquiryId: 'inquiryId',
  userId: 'userId',
  spaceId: 'spaceId'
};

exports.Prisma.ProposalEvaluationReviewOrderByRelevanceFieldEnum = {
  id: 'id',
  reviewerId: 'reviewerId',
  evaluationId: 'evaluationId',
  declineReasons: 'declineReasons',
  declineMessage: 'declineMessage'
};

exports.Prisma.DocusignCredentialOrderByRelevanceFieldEnum = {
  id: 'id',
  docusignAccountId: 'docusignAccountId',
  docusignAccountName: 'docusignAccountName',
  docusignApiBaseUrl: 'docusignApiBaseUrl',
  docusignWebhookId: 'docusignWebhookId',
  refreshToken: 'refreshToken',
  accessToken: 'accessToken',
  userId: 'userId',
  spaceId: 'spaceId',
  webhookApiKey: 'webhookApiKey'
};

exports.Prisma.DocumentToSignOrderByRelevanceFieldEnum = {
  id: 'id',
  docusignEnvelopeId: 'docusignEnvelopeId',
  title: 'title',
  evaluationId: 'evaluationId',
  proposalId: 'proposalId',
  spaceId: 'spaceId'
};

exports.Prisma.DocumentSignerOrderByRelevanceFieldEnum = {
  id: 'id',
  documentToSignId: 'documentToSignId',
  completedBy: 'completedBy',
  email: 'email',
  name: 'name'
};

exports.Prisma.ProposalEvaluationAppealReviewOrderByRelevanceFieldEnum = {
  id: 'id',
  reviewerId: 'reviewerId',
  evaluationId: 'evaluationId',
  declineReasons: 'declineReasons',
  declineMessage: 'declineMessage'
};

exports.Prisma.PullRequestSummaryOrderByRelevanceFieldEnum = {
  id: 'id',
  repoName: 'repoName',
  repoOwner: 'repoOwner',
  prTitle: 'prTitle',
  createdBy: 'createdBy',
  model: 'model',
  prompt: 'prompt',
  summary: 'summary'
};

exports.Prisma.DocusignAllowedRoleOrUserOrderByRelevanceFieldEnum = {
  id: 'id',
  spaceId: 'spaceId',
  roleId: 'roleId',
  userId: 'userId'
};

exports.Prisma.OptimismProjectAttestationOrderByRelevanceFieldEnum = {
  projectRefUID: 'projectRefUID',
  name: 'name',
  metadataAttestationUID: 'metadataAttestationUID',
  metadataUrl: 'metadataUrl',
  projectId: 'projectId'
};

exports.Prisma.GitcoinProjectAttestationOrderByRelevanceFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  schemaId: 'schemaId',
  attestationUID: 'attestationUID'
};

exports.Prisma.CharmUserCredentialOrderByRelevanceFieldEnum = {
  id: 'id',
  schemaId: 'schemaId',
  attestationUID: 'attestationUID',
  userId: 'userId'
};

exports.Prisma.CharmProjectCredentialOrderByRelevanceFieldEnum = {
  projectRefUID: 'projectRefUID',
  name: 'name',
  metadataAttestationUID: 'metadataAttestationUID',
  metadataUrl: 'metadataUrl',
  projectId: 'projectId',
  userId: 'userId'
};

exports.Prisma.CharmQualifyingEventCredentialOrderByRelevanceFieldEnum = {
  id: 'id',
  schemaId: 'schemaId',
  attestationUID: 'attestationUID',
  userId: 'userId',
  resourceUrl: 'resourceUrl',
  proposalId: 'proposalId',
  projectId: 'projectId'
};

exports.Prisma.PushNotificationSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.ProductUpdatesFarcasterFrameOrderByRelevanceFieldEnum = {
  id: 'id',
  text: 'text',
  image: 'image',
  createdBy: 'createdBy',
  projectId: 'projectId',
  createdAtLocal: 'createdAtLocal'
};

exports.Prisma.ConnectWaitlistSlotOrderByRelevanceFieldEnum = {
  id: 'id',
  username: 'username',
  githubLogin: 'githubLogin'
};

exports.Prisma.CryptoEcosystemOrderByRelevanceFieldEnum = {
  subEcosystems: 'subEcosystems',
  title: 'title',
  repoUrls: 'repoUrls',
  organizations: 'organizations'
};

exports.Prisma.CryptoEcosystemChildOrderByRelevanceFieldEnum = {
  parentTitle: 'parentTitle',
  childTitle: 'childTitle'
};

exports.Prisma.CryptoEcosystemRepoOrderByRelevanceFieldEnum = {
  ecosystemTitle: 'ecosystemTitle',
  githubId: 'githubId',
  url: 'url'
};

exports.Prisma.CryptoEcosystemAuthorOrderByRelevanceFieldEnum = {
  login: 'login',
  name: 'name',
  email: 'email',
  twitter: 'twitter'
};

exports.Prisma.CryptoEcosystemPullRequestOrderByRelevanceFieldEnum = {
  githubId: 'githubId',
  repoGithubId: 'repoGithubId',
  title: 'title',
  userGithubLogin: 'userGithubLogin',
  ecosystemTitle: 'ecosystemTitle'
};

exports.Prisma.ScoutOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  path: 'path',
  displayName: 'displayName',
  farcasterName: 'farcasterName',
  telegramName: 'telegramName',
  walletENS: 'walletENS',
  avatar: 'avatar',
  bio: 'bio',
  currentBalanceDevToken: 'currentBalanceDevToken',
  utmCampaign: 'utmCampaign',
  framesNotificationToken: 'framesNotificationToken',
  onchainProfileAttestationUid: 'onchainProfileAttestationUid',
  referralCode: 'referralCode'
};

exports.Prisma.ScoutEmailVerificationOrderByRelevanceFieldEnum = {
  code: 'code',
  email: 'email',
  scoutId: 'scoutId'
};

exports.Prisma.ScoutMergeEventOrderByRelevanceFieldEnum = {
  mergedFromId: 'mergedFromId',
  mergedToId: 'mergedToId'
};

exports.Prisma.BuilderStrikeOrderByRelevanceFieldEnum = {
  id: 'id',
  builderId: 'builderId',
  githubEventId: 'githubEventId',
  onchainStrikeAttestationUid: 'onchainStrikeAttestationUid'
};

exports.Prisma.BuilderEventOrderByRelevanceFieldEnum = {
  id: 'id',
  builderId: 'builderId',
  week: 'week',
  season: 'season',
  description: 'description',
  bonusPartner: 'bonusPartner',
  githubEventId: 'githubEventId',
  gemsPayoutEventId: 'gemsPayoutEventId',
  nftPurchaseEventId: 'nftPurchaseEventId',
  weeklyClaimId: 'weeklyClaimId',
  scoutSocialQuestId: 'scoutSocialQuestId',
  dailyClaimEventId: 'dailyClaimEventId',
  dailyClaimStreakEventId: 'dailyClaimStreakEventId',
  onchainAchievementId: 'onchainAchievementId'
};

exports.Prisma.GithubUserOrderByRelevanceFieldEnum = {
  builderId: 'builderId',
  email: 'email',
  displayName: 'displayName',
  login: 'login'
};

exports.Prisma.GithubRepoOrderByRelevanceFieldEnum = {
  owner: 'owner',
  name: 'name',
  avatar: 'avatar',
  defaultBranch: 'defaultBranch',
  bonusPartner: 'bonusPartner'
};

exports.Prisma.GithubEventOrderByRelevanceFieldEnum = {
  id: 'id',
  commitHash: 'commitHash',
  title: 'title',
  url: 'url'
};

exports.Prisma.NFTPurchaseEventOrderByRelevanceFieldEnum = {
  id: 'id',
  builderNftId: 'builderNftId',
  txHash: 'txHash',
  walletAddress: 'walletAddress',
  senderWalletAddress: 'senderWalletAddress'
};

exports.Prisma.GemsPayoutEventOrderByRelevanceFieldEnum = {
  id: 'id',
  builderId: 'builderId',
  week: 'week',
  season: 'season'
};

exports.Prisma.PointsReceiptOrderByRelevanceFieldEnum = {
  id: 'id',
  eventId: 'eventId',
  recipientId: 'recipientId',
  senderId: 'senderId',
  season: 'season'
};

exports.Prisma.GemsReceiptOrderByRelevanceFieldEnum = {
  id: 'id',
  eventId: 'eventId',
  onchainAttestationUid: 'onchainAttestationUid'
};

exports.Prisma.UserWeeklyStatsOrderByRelevanceFieldEnum = {
  userId: 'userId',
  week: 'week',
  season: 'season'
};

exports.Prisma.UserSeasonStatsOrderByRelevanceFieldEnum = {
  userId: 'userId',
  season: 'season'
};

exports.Prisma.UserAllTimeStatsOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.BuilderNftOrderByRelevanceFieldEnum = {
  id: 'id',
  builderId: 'builderId',
  season: 'season',
  currentPriceDevToken: 'currentPriceDevToken',
  contractAddress: 'contractAddress',
  imageUrl: 'imageUrl',
  congratsImageUrl: 'congratsImageUrl',
  estimatedPayoutDevToken: 'estimatedPayoutDevToken'
};

exports.Prisma.ScoutGameActivityOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  gemsReceiptId: 'gemsReceiptId',
  pointsReceiptId: 'pointsReceiptId',
  nftPurchaseEventId: 'nftPurchaseEventId',
  builderStrikeId: 'builderStrikeId',
  tokensReceiptId: 'tokensReceiptId'
};

exports.Prisma.PendingNftTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  sourceChainTxHash: 'sourceChainTxHash',
  targetCurrencyContractAddress: 'targetCurrencyContractAddress',
  destinationChainTxHash: 'destinationChainTxHash',
  contractAddress: 'contractAddress',
  senderAddress: 'senderAddress'
};

exports.Prisma.ProposalMyWorkColumnOrderByRelevanceFieldEnum = {
  spaceId: 'spaceId',
  formFieldId: 'formFieldId'
};

exports.Prisma.BuilderCardActivityOrderByRelevanceFieldEnum = {
  builderId: 'builderId'
};

exports.Prisma.ScoutWalletOrderByRelevanceFieldEnum = {
  address: 'address',
  scoutId: 'scoutId'
};

exports.Prisma.WeeklyClaimsOrderByRelevanceFieldEnum = {
  id: 'id',
  season: 'season',
  week: 'week',
  merkleTreeRoot: 'merkleTreeRoot',
  totalClaimableDevToken: 'totalClaimableDevToken'
};

exports.Prisma.TokensReceiptOrderByRelevanceFieldEnum = {
  id: 'id',
  value: 'value',
  claimTxHash: 'claimTxHash',
  eventId: 'eventId',
  recipientWalletAddress: 'recipientWalletAddress',
  senderWalletAddress: 'senderWalletAddress'
};

exports.Prisma.ScoutNftOrderByRelevanceFieldEnum = {
  id: 'id',
  builderNftId: 'builderNftId',
  walletAddress: 'walletAddress'
};

exports.Prisma.ScoutSocialQuestOrderByRelevanceFieldEnum = {
  id: 'id',
  type: 'type',
  userId: 'userId',
  season: 'season'
};

exports.Prisma.ScoutDailyClaimEventOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  week: 'week'
};

exports.Prisma.ScoutDailyClaimStreakEventOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  week: 'week'
};

exports.Prisma.ReferralCodeEventOrderByRelevanceFieldEnum = {
  id: 'id',
  builderEventId: 'builderEventId',
  refereeId: 'refereeId',
  bonusBuilderEventId: 'bonusBuilderEventId'
};

exports.Prisma.TalentProfileOrderByRelevanceFieldEnum = {
  builderId: 'builderId',
  address: 'address'
};

exports.Prisma.PartnerRewardEventOrderByRelevanceFieldEnum = {
  week: 'week',
  season: 'season',
  userId: 'userId',
  partner: 'partner'
};

exports.Prisma.AgentTelegramMessageOrderByRelevanceFieldEnum = {
  id: 'id',
  message: 'message'
};

exports.Prisma.ScoutProjectOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  avatar: 'avatar',
  path: 'path',
  description: 'description',
  website: 'website',
  github: 'github'
};

exports.Prisma.ScoutProjectMemberOrderByRelevanceFieldEnum = {
  projectId: 'projectId',
  userId: 'userId',
  createdBy: 'createdBy'
};

exports.Prisma.ScoutProjectContractOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  projectId: 'projectId',
  address: 'address',
  deployerId: 'deployerId',
  deployTxHash: 'deployTxHash'
};

exports.Prisma.ScoutProjectDeployerOrderByRelevanceFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  address: 'address',
  verifiedBy: 'verifiedBy'
};

exports.Prisma.ScoutProjectWalletOrderByRelevanceFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  projectId: 'projectId',
  address: 'address',
  verifiedBy: 'verifiedBy'
};

exports.Prisma.ScoutProjectContractDailyStatsOrderByRelevanceFieldEnum = {
  contractId: 'contractId',
  gasFees: 'gasFees',
  week: 'week'
};

exports.Prisma.ScoutProjectWalletDailyStatsOrderByRelevanceFieldEnum = {
  walletId: 'walletId',
  gasFees: 'gasFees',
  week: 'week'
};

exports.Prisma.ScoutProjectOnchainAchievementOrderByRelevanceFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  week: 'week'
};

exports.Prisma.BuilderStatusEventOrderByRelevanceFieldEnum = {
  attestationUid: 'attestationUid',
  builderId: 'builderId'
};

exports.Prisma.PartnerRewardPayoutOrderByRelevanceFieldEnum = {
  id: 'id',
  walletAddress: 'walletAddress',
  amount: 'amount',
  txHash: 'txHash',
  payoutContractId: 'payoutContractId'
};

exports.Prisma.PartnerRewardPayoutContractOrderByRelevanceFieldEnum = {
  id: 'id',
  season: 'season',
  week: 'week',
  contractAddress: 'contractAddress',
  tokenAddress: 'tokenAddress',
  tokenSymbol: 'tokenSymbol',
  partner: 'partner',
  deployTxHash: 'deployTxHash',
  ipfsCid: 'ipfsCid'
};

exports.Prisma.ScoutProjectContractTransactionOrderByRelevanceFieldEnum = {
  contractId: 'contractId',
  from: 'from',
  to: 'to',
  status: 'status',
  txHash: 'txHash'
};

exports.Prisma.ScoutProjectWalletTransactionOrderByRelevanceFieldEnum = {
  walletId: 'walletId',
  from: 'from',
  to: 'to',
  status: 'status',
  txHash: 'txHash'
};

exports.Prisma.ScoutProjectContractPollEventOrderByRelevanceFieldEnum = {
  contractId: 'contractId'
};

exports.Prisma.ScoutProjectWalletPollEventOrderByRelevanceFieldEnum = {
  walletId: 'walletId'
};

exports.Prisma.ScoutFarcasterNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  notificationType: 'notificationType'
};

exports.Prisma.ScoutEmailNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  userId: 'userId',
  notificationType: 'notificationType'
};

exports.Prisma.ScoutAppNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  notificationType: 'notificationType'
};

exports.Prisma.ScoutMatchupOrderByRelevanceFieldEnum = {
  id: 'id',
  week: 'week',
  createdBy: 'createdBy',
  decentRegistrationTxId: 'decentRegistrationTxId',
  registrationTxId: 'registrationTxId'
};

exports.Prisma.BlockchainTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  hash: 'hash'
};

exports.Prisma.ScoutMatchupSelectionOrderByRelevanceFieldEnum = {
  id: 'id',
  matchupId: 'matchupId',
  developerNftId: 'developerNftId'
};

exports.Prisma.DeveloperNftListingOrderByRelevanceFieldEnum = {
  id: 'id',
  builderNftId: 'builderNftId',
  sellerWallet: 'sellerWallet',
  buyerWallet: 'buyerWallet',
  priceDevToken: 'priceDevToken',
  signature: 'signature',
  hash: 'hash'
};

exports.Prisma.AirdropClaimOrderByRelevanceFieldEnum = {
  id: 'id',
  season: 'season',
  contractAddress: 'contractAddress',
  deployTxHash: 'deployTxHash',
  merkleTreeUrl: 'merkleTreeUrl'
};

exports.Prisma.AirdropClaimPayoutOrderByRelevanceFieldEnum = {
  id: 'id',
  airdropClaimId: 'airdropClaimId',
  claimAmount: 'claimAmount',
  donationAmount: 'donationAmount',
  claimTxHash: 'claimTxHash',
  donationTxHash: 'donationTxHash',
  walletAddress: 'walletAddress'
};

exports.Prisma.DraftSeasonOfferOrderByRelevanceFieldEnum = {
  id: 'id',
  season: 'season',
  value: 'value',
  developerId: 'developerId',
  createdBy: 'createdBy',
  makerWalletAddress: 'makerWalletAddress',
  decentTxHash: 'decentTxHash',
  txHash: 'txHash'
};
exports.SubscriptionTier = exports.$Enums.SubscriptionTier = {
  free: 'free',
  community: 'community',
  enterprise: 'enterprise',
  cancelled: 'cancelled'
};

exports.PagePermissionLevel = exports.$Enums.PagePermissionLevel = {
  full_access: 'full_access',
  editor: 'editor',
  view_comment: 'view_comment',
  view: 'view',
  custom: 'custom'
};

exports.SpacePermissionConfigurationMode = exports.$Enums.SpacePermissionConfigurationMode = {
  custom: 'custom',
  readOnly: 'readOnly',
  collaborative: 'collaborative',
  open: 'open'
};

exports.KycOption = exports.$Enums.KycOption = {
  persona: 'persona',
  synaps: 'synaps'
};

exports.IdentityType = exports.$Enums.IdentityType = {
  Wallet: 'Wallet',
  Discord: 'Discord',
  Telegram: 'Telegram',
  RandomName: 'RandomName',
  UnstoppableDomain: 'UnstoppableDomain',
  Google: 'Google',
  VerifiedEmail: 'VerifiedEmail',
  Lens: 'Lens',
  Farcaster: 'Farcaster'
};

exports.Feature = exports.$Enums.Feature = {
  member_directory: 'member_directory',
  proposals: 'proposals',
  forum: 'forum',
  bounties: 'bounties',
  rewards: 'rewards'
};

exports.PageType = exports.$Enums.PageType = {
  board: 'board',
  board_template: 'board_template',
  bounty: 'bounty',
  bounty_template: 'bounty_template',
  page: 'page',
  page_template: 'page_template',
  card: 'card',
  card_synced: 'card_synced',
  card_template: 'card_template',
  proposal: 'proposal',
  proposal_notes: 'proposal_notes',
  proposal_template: 'proposal_template',
  inline_board: 'inline_board',
  inline_linked_board: 'inline_linked_board',
  linked_board: 'linked_board'
};

exports.FontFamily = exports.$Enums.FontFamily = {
  default: 'default',
  serif: 'serif',
  mono: 'mono'
};

exports.UserSpaceActionType = exports.$Enums.UserSpaceActionType = {
  view_page: 'view_page',
  app_loaded: 'app_loaded'
};

exports.VoteStatus = exports.$Enums.VoteStatus = {
  InProgress: 'InProgress',
  Passed: 'Passed',
  Rejected: 'Rejected',
  Cancelled: 'Cancelled'
};

exports.VoteType = exports.$Enums.VoteType = {
  Approval: 'Approval',
  SingleChoice: 'SingleChoice',
  MultiChoice: 'MultiChoice'
};

exports.VoteStrategy = exports.$Enums.VoteStrategy = {
  regular: 'regular',
  token: 'token',
  snapshot: 'snapshot'
};

exports.VoteContext = exports.$Enums.VoteContext = {
  inline: 'inline',
  proposal: 'proposal'
};

exports.CategorySubscriptionMode = exports.$Enums.CategorySubscriptionMode = {
  whitelist: 'whitelist',
  blacklist: 'blacklist'
};

exports.NotificationType = exports.$Enums.NotificationType = {
  multisig: 'multisig',
  mention: 'mention',
  vote: 'vote',
  proposal: 'proposal',
  bounty: 'bounty',
  post_comment: 'post_comment',
  page_comment: 'page_comment',
  forum: 'forum'
};

exports.NotificationChannel = exports.$Enums.NotificationChannel = {
  email: 'email',
  webapp: 'webapp'
};

exports.PublicInviteLinkContext = exports.$Enums.PublicInviteLinkContext = {
  proposals: 'proposals'
};

exports.RewardType = exports.$Enums.RewardType = {
  token: 'token',
  none: 'none',
  custom: 'custom'
};

exports.BountyStatus = exports.$Enums.BountyStatus = {
  suggestion: 'suggestion',
  draft: 'draft',
  open: 'open',
  complete: 'complete',
  paid: 'paid'
};

exports.BountyPermissionLevel = exports.$Enums.BountyPermissionLevel = {
  reviewer: 'reviewer',
  creator: 'creator',
  submitter: 'submitter'
};

exports.BountyOperation = exports.$Enums.BountyOperation = {
  work: 'work',
  review: 'review',
  lock: 'lock',
  approve_applications: 'approve_applications',
  grant_permissions: 'grant_permissions',
  mark_paid: 'mark_paid'
};

exports.ApplicationStatus = exports.$Enums.ApplicationStatus = {
  applied: 'applied',
  submission_rejected: 'submission_rejected',
  inProgress: 'inProgress',
  review: 'review',
  rejected: 'rejected',
  processing: 'processing',
  complete: 'complete',
  paid: 'paid',
  cancelled: 'cancelled'
};

exports.TokenGateType = exports.$Enums.TokenGateType = {
  lit: 'lit',
  unlock: 'unlock',
  hypersub: 'hypersub'
};

exports.WalletType = exports.$Enums.WalletType = {
  metamask: 'metamask',
  gnosis: 'gnosis'
};

exports.RoleSource = exports.$Enums.RoleSource = {
  guild_xyz: 'guild_xyz',
  collabland: 'collabland',
  summon: 'summon'
};

exports.PageOperations = exports.$Enums.PageOperations = {
  read: 'read',
  delete: 'delete',
  edit_position: 'edit_position',
  edit_content: 'edit_content',
  edit_path: 'edit_path',
  grant_permissions: 'grant_permissions',
  comment: 'comment',
  create_poll: 'create_poll',
  delete_attached_bounty: 'delete_attached_bounty',
  edit_lock: 'edit_lock'
};

exports.SpaceOperation = exports.$Enums.SpaceOperation = {
  createPage: 'createPage',
  createBounty: 'createBounty',
  createForumCategory: 'createForumCategory',
  moderateForums: 'moderateForums',
  reviewProposals: 'reviewProposals',
  deleteAnyPage: 'deleteAnyPage',
  deleteAnyBounty: 'deleteAnyBounty',
  deleteAnyProposal: 'deleteAnyProposal',
  createProposals: 'createProposals'
};

exports.ProposalStatus = exports.$Enums.ProposalStatus = {
  draft: 'draft',
  published: 'published'
};

exports.ProposalOperation = exports.$Enums.ProposalOperation = {
  edit: 'edit',
  edit_rewards: 'edit_rewards',
  view: 'view',
  view_notes: 'view_notes',
  view_private_fields: 'view_private_fields',
  delete: 'delete',
  create_vote: 'create_vote',
  comment: 'comment',
  evaluate: 'evaluate',
  make_public: 'make_public',
  archive: 'archive',
  unarchive: 'unarchive',
  move: 'move',
  evaluate_appeal: 'evaluate_appeal',
  complete_evaluation: 'complete_evaluation'
};

exports.ProposalSystemRole = exports.$Enums.ProposalSystemRole = {
  author: 'author',
  space_member: 'space_member',
  current_reviewer: 'current_reviewer',
  all_reviewers: 'all_reviewers',
  public: 'public'
};

exports.ProposalEvaluationType = exports.$Enums.ProposalEvaluationType = {
  feedback: 'feedback',
  vote: 'vote',
  rubric: 'rubric',
  pass_fail: 'pass_fail',
  sign_documents: 'sign_documents'
};

exports.ProposalEvaluationResult = exports.$Enums.ProposalEvaluationResult = {
  pass: 'pass',
  fail: 'fail'
};

exports.ProposalRubricCriteriaType = exports.$Enums.ProposalRubricCriteriaType = {
  range: 'range'
};

exports.ProfileItemType = exports.$Enums.ProfileItemType = {
  community: 'community',
  nft: 'nft',
  poap: 'poap',
  vc: 'vc'
};

exports.WorkspaceEventType = exports.$Enums.WorkspaceEventType = {
  proposal_status_change: 'proposal_status_change'
};

exports.MemberPropertyType = exports.$Enums.MemberPropertyType = {
  text: 'text',
  text_multiline: 'text_multiline',
  number: 'number',
  email: 'email',
  phone: 'phone',
  url: 'url',
  select: 'select',
  multiselect: 'multiselect',
  role: 'role',
  profile_pic: 'profile_pic',
  timezone: 'timezone',
  discord: 'discord',
  twitter: 'twitter',
  bio: 'bio',
  join_date: 'join_date',
  linked_in: 'linked_in',
  farcaster: 'farcaster',
  github: 'github',
  google: 'google',
  telegram: 'telegram',
  wallet: 'wallet'
};

exports.VisibilityView = exports.$Enums.VisibilityView = {
  gallery: 'gallery',
  table: 'table',
  profile: 'profile'
};

exports.MemberPropertyPermissionLevel = exports.$Enums.MemberPropertyPermissionLevel = {
  view: 'view'
};

exports.PostCategoryPermissionLevel = exports.$Enums.PostCategoryPermissionLevel = {
  category_admin: 'category_admin',
  moderator: 'moderator',
  full_access: 'full_access',
  comment_vote: 'comment_vote',
  view: 'view',
  custom: 'custom'
};

exports.PostCategoryOperation = exports.$Enums.PostCategoryOperation = {
  manage_permissions: 'manage_permissions',
  delete_category: 'delete_category',
  edit_category: 'edit_category',
  create_post: 'create_post',
  view_posts: 'view_posts',
  comment_posts: 'comment_posts'
};

exports.PostOperation = exports.$Enums.PostOperation = {
  view_post: 'view_post',
  edit_post: 'edit_post',
  delete_post: 'delete_post',
  pin_post: 'pin_post',
  lock_post: 'lock_post',
  add_comment: 'add_comment',
  delete_comments: 'delete_comments',
  upvote: 'upvote',
  downvote: 'downvote'
};

exports.ApiPageKeyType = exports.$Enums.ApiPageKeyType = {
  typeform: 'typeform'
};

exports.FormFieldType = exports.$Enums.FormFieldType = {
  project_profile: 'project_profile',
  short_text: 'short_text',
  long_text: 'long_text',
  number: 'number',
  email: 'email',
  phone: 'phone',
  url: 'url',
  select: 'select',
  multiselect: 'multiselect',
  wallet: 'wallet',
  date: 'date',
  person: 'person',
  label: 'label',
  image: 'image',
  file: 'file',
  milestone: 'milestone',
  optimism_project_profile: 'optimism_project_profile'
};

exports.AttestationType = exports.$Enums.AttestationType = {
  proposal: 'proposal',
  reward: 'reward',
  external: 'external'
};

exports.CredentialEventType = exports.$Enums.CredentialEventType = {
  proposal_created: 'proposal_created',
  proposal_approved: 'proposal_approved',
  reward_submission_approved: 'reward_submission_approved'
};

exports.SunnyAwardsProjectType = exports.$Enums.SunnyAwardsProjectType = {
  creator: 'creator',
  app: 'app',
  other: 'other'
};

exports.ProjectSource = exports.$Enums.ProjectSource = {
  charmverse: 'charmverse',
  connect: 'connect',
  sunny_awards: 'sunny_awards',
  farcaster: 'farcaster'
};

exports.ExternalProjectSource = exports.$Enums.ExternalProjectSource = {
  gitcoin: 'gitcoin',
  questbook: 'questbook'
};

exports.SynapsUserKycStatus = exports.$Enums.SynapsUserKycStatus = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  RESUBMISSION_REQUIRED: 'RESUBMISSION_REQUIRED',
  SUBMISSION_REQUIRED: 'SUBMISSION_REQUIRED',
  PENDING_VERIFICATION: 'PENDING_VERIFICATION'
};

exports.PersonaUserKycStatus = exports.$Enums.PersonaUserKycStatus = {
  created: 'created',
  pending: 'pending',
  completed: 'completed',
  failed: 'failed',
  expired: 'expired',
  needs_review: 'needs_review',
  approved: 'approved',
  declined: 'declined'
};

exports.DocumentSignatureStatus = exports.$Enums.DocumentSignatureStatus = {
  pending: 'pending',
  completed: 'completed'
};

exports.PullRequestStatus = exports.$Enums.PullRequestStatus = {
  open: 'open',
  closed: 'closed',
  merged: 'merged'
};

exports.GitcoinProjectAttestationType = exports.$Enums.GitcoinProjectAttestationType = {
  application: 'application',
  profile: 'profile'
};

exports.QualifyingEventType = exports.$Enums.QualifyingEventType = {
  proposal_published: 'proposal_published',
  pull_request_merged: 'pull_request_merged'
};

exports.PushNotificationSource = exports.$Enums.PushNotificationSource = {
  sunnyawards: 'sunnyawards',
  connect: 'connect',
  charmverse: 'charmverse'
};

exports.BuilderStatus = exports.$Enums.BuilderStatus = {
  applied: 'applied',
  rejected: 'rejected',
  approved: 'approved',
  banned: 'banned'
};

exports.BuilderEventType = exports.$Enums.BuilderEventType = {
  daily_commit: 'daily_commit',
  merged_pull_request: 'merged_pull_request',
  waitlist_airdrop: 'waitlist_airdrop',
  misc_event: 'misc_event',
  nft_purchase: 'nft_purchase',
  proposal_passed: 'proposal_passed',
  gems_payout: 'gems_payout',
  daily_claim: 'daily_claim',
  daily_claim_streak: 'daily_claim_streak',
  social_quest: 'social_quest',
  referral: 'referral',
  referral_bonus: 'referral_bonus',
  onchain_achievement: 'onchain_achievement',
  matchup_winner: 'matchup_winner'
};

exports.GithubRepoOwnerType = exports.$Enums.GithubRepoOwnerType = {
  user: 'user',
  org: 'org'
};

exports.GithubEventType = exports.$Enums.GithubEventType = {
  merged_pull_request: 'merged_pull_request',
  closed_pull_request: 'closed_pull_request',
  commit: 'commit'
};

exports.GemsReceiptType = exports.$Enums.GemsReceiptType = {
  first_pr: 'first_pr',
  third_pr_in_streak: 'third_pr_in_streak',
  regular_pr: 'regular_pr',
  regular_pr_unreviewed: 'regular_pr_unreviewed',
  daily_commit: 'daily_commit',
  onchain_achievement: 'onchain_achievement'
};

exports.BuilderNftType = exports.$Enums.BuilderNftType = {
  default: 'default',
  starter_pack: 'starter_pack'
};

exports.ScoutGameActivityType = exports.$Enums.ScoutGameActivityType = {
  gems_first_pr: 'gems_first_pr',
  gems_third_pr_in_streak: 'gems_third_pr_in_streak',
  gems_regular_pr: 'gems_regular_pr',
  daily_commit: 'daily_commit',
  nft_purchase: 'nft_purchase',
  builder_strike: 'builder_strike',
  builder_suspended: 'builder_suspended',
  points: 'points'
};

exports.ActivityRecipientType = exports.$Enums.ActivityRecipientType = {
  builder: 'builder',
  scout: 'scout'
};

exports.TransactionStatus = exports.$Enums.TransactionStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed'
};

exports.ReferralPlatform = exports.$Enums.ReferralPlatform = {
  telegram: 'telegram',
  farcaster: 'farcaster',
  webapp: 'webapp',
  onchain_webapp: 'onchain_webapp',
  onchain_cron: 'onchain_cron',
  unknown: 'unknown'
};

exports.MessageSender = exports.$Enums.MessageSender = {
  user: 'user',
  agent: 'agent'
};

exports.ScoutProjectMemberRole = exports.$Enums.ScoutProjectMemberRole = {
  owner: 'owner',
  member: 'member'
};

exports.ChainType = exports.$Enums.ChainType = {
  evm: 'evm',
  solana: 'solana'
};

exports.OnchainAchievementTier = exports.$Enums.OnchainAchievementTier = {
  bronze: 'bronze',
  silver: 'silver',
  gold: 'gold'
};

exports.BuilderStatusEventType = exports.$Enums.BuilderStatusEventType = {
  registered: 'registered',
  banned: 'banned',
  unbanned: 'unbanned'
};

exports.PartnerRewardPayoutContractProvider = exports.$Enums.PartnerRewardPayoutContractProvider = {
  thirdweb: 'thirdweb',
  sablier: 'sablier'
};

exports.DecentTxStatus = exports.$Enums.DecentTxStatus = {
  initial: 'initial',
  pending: 'pending',
  success: 'success',
  failed: 'failed'
};

exports.Prisma.ModelName = {
  Space: 'Space',
  StripeSubscription: 'StripeSubscription',
  SpaceApiToken: 'SpaceApiToken',
  SuperApiToken: 'SuperApiToken',
  Page: 'Page',
  UserSpaceAction: 'UserSpaceAction',
  PageComment: 'PageComment',
  PageCommentVote: 'PageCommentVote',
  PageDiff: 'PageDiff',
  Block: 'Block',
  UserVote: 'UserVote',
  VoteOptions: 'VoteOptions',
  Vote: 'Vote',
  User: 'User',
  FarcasterUser: 'FarcasterUser',
  VerifiedEmail: 'VerifiedEmail',
  UserWallet: 'UserWallet',
  UserSpaceNotificationSettings: 'UserSpaceNotificationSettings',
  UserNotificationState: 'UserNotificationState',
  UserNotification: 'UserNotification',
  UserDetails: 'UserDetails',
  TelegramUser: 'TelegramUser',
  DiscordUser: 'DiscordUser',
  Poap: 'Poap',
  FavoritePage: 'FavoritePage',
  UserTokenGate: 'UserTokenGate',
  SpaceRole: 'SpaceRole',
  InviteLink: 'InviteLink',
  Bounty: 'Bounty',
  BountyPermission: 'BountyPermission',
  Application: 'Application',
  Transaction: 'Transaction',
  TokenGate: 'TokenGate',
  PaymentMethod: 'PaymentMethod',
  UserGnosisSafe: 'UserGnosisSafe',
  Role: 'Role',
  TokenGateToRole: 'TokenGateToRole',
  InviteLinkToRole: 'InviteLinkToRole',
  SpaceRoleToRole: 'SpaceRoleToRole',
  PagePermission: 'PagePermission',
  SpacePermission: 'SpacePermission',
  Thread: 'Thread',
  Comment: 'Comment',
  Proposal: 'Proposal',
  ProposalWorkflow: 'ProposalWorkflow',
  ProposalEvaluationPermission: 'ProposalEvaluationPermission',
  ProposalEvaluation: 'ProposalEvaluation',
  ProposalBlock: 'ProposalBlock',
  RewardBlock: 'RewardBlock',
  ProposalAuthor: 'ProposalAuthor',
  ProposalReviewer: 'ProposalReviewer',
  ProposalEvaluationApprover: 'ProposalEvaluationApprover',
  ProposalAppealReviewer: 'ProposalAppealReviewer',
  ProposalRubricCriteria: 'ProposalRubricCriteria',
  ProposalRubricCriteriaAnswer: 'ProposalRubricCriteriaAnswer',
  DraftProposalRubricCriteriaAnswer: 'DraftProposalRubricCriteriaAnswer',
  ProfileItem: 'ProfileItem',
  WorkspaceEvent: 'WorkspaceEvent',
  MemberProperty: 'MemberProperty',
  MemberPropertyValue: 'MemberPropertyValue',
  MemberPropertyPermission: 'MemberPropertyPermission',
  PostCategory: 'PostCategory',
  Post: 'Post',
  PostToPostTag: 'PostToPostTag',
  PostUpDownVote: 'PostUpDownVote',
  PostComment: 'PostComment',
  ApplicationComment: 'ApplicationComment',
  PostCommentUpDownVote: 'PostCommentUpDownVote',
  PostTag: 'PostTag',
  UnstoppableDomain: 'UnstoppableDomain',
  WebhookSubscription: 'WebhookSubscription',
  GoogleAccount: 'GoogleAccount',
  GoogleCredential: 'GoogleCredential',
  PostCategoryPermission: 'PostCategoryPermission',
  ApiPageKey: 'ApiPageKey',
  BlockCount: 'BlockCount',
  UserNotificationMetadata: 'UserNotificationMetadata',
  BountyNotification: 'BountyNotification',
  DocumentNotification: 'DocumentNotification',
  CardNotification: 'CardNotification',
  PostNotification: 'PostNotification',
  ProposalNotification: 'ProposalNotification',
  VoteNotification: 'VoteNotification',
  CustomNotification: 'CustomNotification',
  SQSMessage: 'SQSMessage',
  BlacklistedSpaceUser: 'BlacklistedSpaceUser',
  BlacklistedUser: 'BlacklistedUser',
  AdditionalBlockQuota: 'AdditionalBlockQuota',
  Form: 'Form',
  FormField: 'FormField',
  FormFieldAnswer: 'FormFieldAnswer',
  CredentialTemplate: 'CredentialTemplate',
  IssuedCredential: 'IssuedCredential',
  Otp: 'Otp',
  RecoveryCode: 'RecoveryCode',
  CharmWallet: 'CharmWallet',
  CharmTransaction: 'CharmTransaction',
  FavoriteCredential: 'FavoriteCredential',
  ReferralCode: 'ReferralCode',
  ReferralCodeUseEvent: 'ReferralCodeUseEvent',
  PendingSafeTransaction: 'PendingSafeTransaction',
  ProjectMember: 'ProjectMember',
  Project: 'Project',
  ExternalProject: 'ExternalProject',
  SpaceGithubConnection: 'SpaceGithubConnection',
  RewardsGithubRepo: 'RewardsGithubRepo',
  SynapsCredential: 'SynapsCredential',
  SynapsUserKyc: 'SynapsUserKyc',
  PersonaCredential: 'PersonaCredential',
  PersonaUserKyc: 'PersonaUserKyc',
  ProposalEvaluationReview: 'ProposalEvaluationReview',
  DocusignCredential: 'DocusignCredential',
  DocumentToSign: 'DocumentToSign',
  DocumentSigner: 'DocumentSigner',
  ProposalEvaluationAppealReview: 'ProposalEvaluationAppealReview',
  PullRequestSummary: 'PullRequestSummary',
  DocusignAllowedRoleOrUser: 'DocusignAllowedRoleOrUser',
  OptimismProjectAttestation: 'OptimismProjectAttestation',
  GitcoinProjectAttestation: 'GitcoinProjectAttestation',
  CharmUserCredential: 'CharmUserCredential',
  CharmProjectCredential: 'CharmProjectCredential',
  CharmQualifyingEventCredential: 'CharmQualifyingEventCredential',
  PushNotificationSubscription: 'PushNotificationSubscription',
  ProductUpdatesFarcasterFrame: 'ProductUpdatesFarcasterFrame',
  ConnectWaitlistSlot: 'ConnectWaitlistSlot',
  CryptoEcosystem: 'CryptoEcosystem',
  CryptoEcosystemChild: 'CryptoEcosystemChild',
  CryptoEcosystemRepo: 'CryptoEcosystemRepo',
  CryptoEcosystemAuthor: 'CryptoEcosystemAuthor',
  CryptoEcosystemPullRequest: 'CryptoEcosystemPullRequest',
  Scout: 'Scout',
  ScoutEmailVerification: 'ScoutEmailVerification',
  ScoutMergeEvent: 'ScoutMergeEvent',
  BuilderStrike: 'BuilderStrike',
  BuilderEvent: 'BuilderEvent',
  GithubUser: 'GithubUser',
  GithubRepo: 'GithubRepo',
  GithubEvent: 'GithubEvent',
  NFTPurchaseEvent: 'NFTPurchaseEvent',
  GemsPayoutEvent: 'GemsPayoutEvent',
  PointsReceipt: 'PointsReceipt',
  GemsReceipt: 'GemsReceipt',
  UserWeeklyStats: 'UserWeeklyStats',
  UserSeasonStats: 'UserSeasonStats',
  UserAllTimeStats: 'UserAllTimeStats',
  BuilderNft: 'BuilderNft',
  ScoutGameActivity: 'ScoutGameActivity',
  PendingNftTransaction: 'PendingNftTransaction',
  ProposalMyWorkColumn: 'ProposalMyWorkColumn',
  BuilderCardActivity: 'BuilderCardActivity',
  ScoutWallet: 'ScoutWallet',
  WeeklyClaims: 'WeeklyClaims',
  TokensReceipt: 'TokensReceipt',
  ScoutNft: 'ScoutNft',
  ScoutSocialQuest: 'ScoutSocialQuest',
  ScoutDailyClaimEvent: 'ScoutDailyClaimEvent',
  ScoutDailyClaimStreakEvent: 'ScoutDailyClaimStreakEvent',
  ReferralCodeEvent: 'ReferralCodeEvent',
  TalentProfile: 'TalentProfile',
  PartnerRewardEvent: 'PartnerRewardEvent',
  AgentTelegramMessage: 'AgentTelegramMessage',
  ScoutProject: 'ScoutProject',
  ScoutProjectMember: 'ScoutProjectMember',
  ScoutProjectContract: 'ScoutProjectContract',
  ScoutProjectDeployer: 'ScoutProjectDeployer',
  ScoutProjectWallet: 'ScoutProjectWallet',
  ScoutProjectContractDailyStats: 'ScoutProjectContractDailyStats',
  ScoutProjectWalletDailyStats: 'ScoutProjectWalletDailyStats',
  ScoutProjectOnchainAchievement: 'ScoutProjectOnchainAchievement',
  BuilderStatusEvent: 'BuilderStatusEvent',
  PartnerRewardPayout: 'PartnerRewardPayout',
  PartnerRewardPayoutContract: 'PartnerRewardPayoutContract',
  ScoutProjectContractTransaction: 'ScoutProjectContractTransaction',
  ScoutProjectWalletTransaction: 'ScoutProjectWalletTransaction',
  ScoutProjectContractPollEvent: 'ScoutProjectContractPollEvent',
  ScoutProjectWalletPollEvent: 'ScoutProjectWalletPollEvent',
  ScoutFarcasterNotification: 'ScoutFarcasterNotification',
  ScoutEmailNotification: 'ScoutEmailNotification',
  ScoutAppNotification: 'ScoutAppNotification',
  ScoutMatchup: 'ScoutMatchup',
  BlockchainTransaction: 'BlockchainTransaction',
  ScoutMatchupSelection: 'ScoutMatchupSelection',
  DeveloperNftListing: 'DeveloperNftListing',
  AirdropClaim: 'AirdropClaim',
  AirdropClaimPayout: 'AirdropClaimPayout',
  DraftSeasonOffer: 'DraftSeasonOffer'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
